webpackJsonp([3],{

/***/ "+nvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue__ = __webpack_require__("jMug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf09f79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_split_badge_vue__ = __webpack_require__("n0dT");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_split_badge_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf09f79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_split_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\expense-split-badge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1bf09f79", Component.options)
  } else {
    hotAPI.reload("data-v-1bf09f79", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/qnk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue__ = __webpack_require__("jP3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0c84a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debts_vue__ = __webpack_require__("QM1v");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_debts_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0c84a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\apps\\anonymous\\debts.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cf0c84a6", Component.options)
  } else {
    hotAPI.reload("data-v-cf0c84a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "04nl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: { 'text': String },
	computed: {
		lines: function lines() {
			return this.text ? this.text.split('\n') : [];
		}
	}
};

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "14kM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _toastr = __webpack_require__("vQJi");

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_toastr2.default.options = {
	positionClass: "toast-bottom-left",
	closeButton: true
};

_toastr2.default.tr = function () {
	return _toastr2.default.success(_vue2.default.prototype.$formatMessage.apply(null, arguments));
};

_toastr2.default.cancel = function (message, promiseMaker) {
	message = [message, "<button type='button' class='btn btn-link'>", _vue2.default.prototype.$formatMessage("undo"), "</button>"].join('');
	var $toast = _toastr2.default.success(message, null, { timeOut: 0, extendedTimeOut: 0, tapToDismiss: false });

	var hide = function hide() {
		_toastr2.default.clear($toast);
	};
	var hideTimeout = setTimeout(hide, 6000);

	$toast.find('button.btn').click(function (e) {
		$(this).prop('disabled', true);
		clearTimeout(hideTimeout);

		promiseMaker().then(hide, hide);

		return false;
	});

	return $toast;
};

exports.default = _toastr2.default;

/***/ }),

/***/ "1USJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.EntityWatcher = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _key = __webpack_require__("C3wo");

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _ajax = __webpack_require__("gwph");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function groupByParent(map, rawEntity) {
	var key = void 0;
	if (rawEntity.id) {
		key = rawEntity;
	} else {
		key = new _key.Key(rawEntity.key);
	}
	var parentKey = key.parent || null;
	if (parentKey) {
		parentKey = parentKey.toString();
	}
	var table = map.get(parentKey);
	if (!table) {
		table = new Map();
		map.set(parentKey, table);
	}
	var children = table.get(key.kind);
	if (!children) {
		children = [];
		table.set(key.kind, children);
	}
	if (rawEntity.id) {
		children.push(rawEntity.id);
	} else {
		children.push(rawEntity);
	}
	return map;
}

function foreachGroupedByParent(map, callback) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = _slicedToArray(_ref, 2);

			var parentKey = _ref2[0];
			var table = _ref2[1];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = table[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = _slicedToArray(_ref3, 2);

					var kind = _ref4[0];
					var rawEntities = _ref4[1];

					callback(_key.Key.fromString(parentKey), kind, rawEntities);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

var eventsKeys = new Set();

var DatastoreEvent = function DatastoreEvent() {
	_classCallCheck(this, DatastoreEvent);

	this.created = [];
	this.updated = [];
	this.deleted = [];
};

function handleServerEvent(dbEvent) {
	var eventKey = new _key.Key(dbEvent.key).toString();
	var storeEvent = new DatastoreEvent();

	if (!eventsKeys.has(eventKey)) {
		var _loop = function _loop(action) {
			if (dbEvent[action]) {
				var toPut = new Map();
				dbEvent[action].reduce(groupByParent, toPut);
				foreachGroupedByParent(toPut, function (parentKey, kind, rawEntities) {
					var _storeEvent$action;

					(_storeEvent$action = storeEvent[action]).push.apply(_storeEvent$action, _toConsumableArray(_store2.default.put(parentKey, kind, rawEntities)));
				});
			}
		};

		var _arr = ['created', 'updated'];

		for (var _i = 0; _i < _arr.length; _i++) {
			var action = _arr[_i];
			_loop(action);
		}

		if (dbEvent.deleted) {
			var toDelete = dbEvent.deleted.map(function (e) {
				return new _key.Key(e);
			}).reduce(groupByParent, new Map());
			foreachGroupedByParent(toDelete, function (parentKey, kind, ids) {
				var _storeEvent$deleted;

				(_storeEvent$deleted = storeEvent.deleted).push.apply(_storeEvent$deleted, _toConsumableArray(_store2.default.delete(parentKey, kind, ids)));
			});
		}

		eventsKeys.add(eventKey);
	}

	return Promise.resolve(storeEvent);
}

function createUrl(parentKey, kind, id) {
	var urlParts = ['/api'];
	if (parentKey) {
		urlParts = urlParts.concat(parentKey.data);
	}
	if (kind) {
		urlParts.push(kind);
	}
	if (id) {
		urlParts.push(id);
	}
	return urlParts.join('/');
}

var windowVisibility = function () {
	var hidden = "hidden";

	if (hidden in document) document.addEventListener("visibilitychange", onchange);else if ((hidden = "mozHidden") in document) document.addEventListener("mozvisibilitychange", onchange);else if ((hidden = "webkitHidden") in document) document.addEventListener("webkitvisibilitychange", onchange);else if ((hidden = "msHidden") in document) document.addEventListener("msvisibilitychange", onchange);else if ("onfocusin" in document) document.onfocusin = document.onfocusout = onchange;else window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

	var visibility = { visible: true };

	function onchange(evt) {
		var evtMap = {
			focus: true, focusin: true, pageshow: true, blur: false, focusout: false, pagehide: false
		};

		evt = evt || window.event;
		if (evt.type in evtMap) visibility.visible = evtMap[evt.type];else visibility.visible = !this[hidden];
		$(visibility).trigger('change');
	}

	if (document[hidden] !== undefined) onchange({ type: document[hidden] ? "blur" : "focus" });

	return visibility;
}();

var EntityWatcher = exports.EntityWatcher = function () {
	function EntityWatcher(entityKey) {
		_classCallCheck(this, EntityWatcher);

		this.entityKey = entityKey;
		this.timer = null;
		this.running = false;
		this.started = false;
		this.paused = false;
		this.lastEventTime = null;

		this.afterPoll = this._afterPoll.bind(this);
		this.pollEvents = this._pollEvents.bind(this);
		this.handlerServerEvents = this._handlerServerEvents.bind(this);
		this.onWindowVisibilityChanged = this._onWindowVisibilityChanged.bind(this);
	}

	_createClass(EntityWatcher, [{
		key: 'start',
		value: function start() {
			var _this = this;

			this.started = true;

			_ajax2.default.send(createUrl(this.entityKey, 'Event') + "?limit=1&order=-time", 'GET', null, { doNotNotify: true }).then(function (events) {
				_this.lastEventTime = events.length ? new Date(events[0].time) : new Date();
				_this._afterPoll();
			});

			$(windowVisibility).on('change', this.onWindowVisibilityChanged);

			this._log();
			return this;
		}
	}, {
		key: 'stop',
		value: function stop() {
			clearTimeout(this.timer);
			this.started = false;
			this._log();
			return this;
		}
	}, {
		key: '_log',
		value: function _log() {
			var now = new Date();
			console.debug('Watcher', this.entityKey.toString(), this.started ? 'started' : 'stopped', 'at', now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds());
		}
	}, {
		key: '_handlerServerEvents',
		value: function _handlerServerEvents(events) {
			events.forEach(handleServerEvent);
			if (events.length) {
				this.lastEventTime = new Date(events[events.length - 1].time);
			}
		}
	}, {
		key: '_afterPoll',
		value: function _afterPoll() {
			if (this.started && !this.paused) {
				this.timer = setTimeout(this.pollEvents, 30000);
			}
		}
	}, {
		key: '_pollEvents',
		value: function _pollEvents() {
			var url = [createUrl(this.entityKey, 'Event'), "?filter=", encodeURIComponent("time >," + this.lastEventTime.toISOString()), "&order=time"].join('');
			_ajax2.default.send(url, 'GET', null, { doNotNotify: true }).then(this.handlerServerEvents).then(this.afterPoll, this.afterPoll);
		}
	}, {
		key: '_onWindowVisibilityChanged',
		value: function _onWindowVisibilityChanged() {
			if (this.started) {
				if (windowVisibility.visible) {
					this.paused = false;
					this._pollEvents();
					console.debug('Watcher resumed');
				} else {
					clearTimeout(this.timer);
					this.paused = true;
					console.debug('Watcher paused');
				}
			}
		}
	}]);

	return EntityWatcher;
}();

var getPromises = new Map();

exports.default = {
	get: function get(parentKey, kind, ids, limit, offset, orders) {
		var idsIsArray = ids instanceof Array;
		var urlParts = [createUrl(parentKey, kind, idsIsArray ? null : ids)];
		if (!idsIsArray) {
			if (limit) {
				urlParts.push('?limit=', limit, '&offset=', offset);
				if (orders) {
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = orders[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var order = _step3.value;

							urlParts.push('&order=', order);
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
				}
			}
		} else if (ids) {
			var first = true;
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = ids[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var id = _step4.value;

					if (first) {
						urlParts.push('/?');
						first = false;
					} else {
						urlParts.push('&');
					}
					urlParts.push('id=', id);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
		}
		var url = urlParts.join('');
		var promise = getPromises.get(url);
		if (!promise) {
			promise = _ajax2.default.send(url, 'GET');
			var removePromise = function removePromise() {
				getPromises.delete(url);
			};
			promise.then(removePromise, removePromise);
			getPromises.set(url, promise);
		}
		return promise;
	},
	post: function post(parentKey, kind, entity) {
		return _ajax2.default.send(createUrl(parentKey, kind), 'POST', entity).then(handleServerEvent);
	},
	put: function put(entity) {
		return _ajax2.default.send(createUrl(entity.key), 'PUT', entity).then(handleServerEvent);
	},
	delete: function _delete(parentKey, kind, ids, options) {
		if (ids instanceof Array) {
			ids = ids.join('-');
		}
		var url = createUrl(parentKey, kind) + '/?ids=' + ids;
		return _ajax2.default.send(url, 'DELETE', null, options).then(handleServerEvent);
	}
};

/***/ }),

/***/ "50/L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		split: Array,
		sheet: Object,
		disabled: { type: Boolean, default: false },
		showCheckbox: { type: Boolean, default: true }
	},

	computed: {
		sortedSplit: function sortedSplit() {
			var _this = this;

			var bookersIds = new Set(this.sheet.bookersIds());
			return this.split.sort(function (shareA, shareB) {
				return _this.sheet.getBooker(shareA.id).name.localeCompare(_this.sheet.getBooker(shareB.id).name);
			}).map(function (share) {
				var removed = !bookersIds.has(share.id);
				return { share: share, removed: removed, title: removed ? _this.$formatMessage('expense_split_sheeter_deleted') : '' };
			});
		}
	},

	methods: {
		toggleSplit: function toggleSplit($event, part) {
			part.value = Number($event.target.checked);
		}
	}
};

/***/ }),

/***/ "61OL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		label: String,
		value: Number,
		currency: String,
		disabled: Boolean
	},

	methods: {
		focusInput: function focusInput() {
			if (!this.disabled) {
				$(this.$el).find('input').focus();
			}
		},
		onInput: function onInput(event) {
			this.$emit('input', event.target.value || 0);
		},
		onInputFocus: function onInputFocus() {
			var $input = $(this.$el).removeClass('inactive', true).find('input');
			setTimeout(function () {
				$input.select();
			});
		},
		onInputBlur: function onInputBlur() {
			$(this.$el).toggleClass('inactive', true);
		}
	}
};

/***/ }),

/***/ "6bTo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["avatar", _vm.className] }, [
    _vm.icon
      ? _c("i", { class: "icon-" + _vm.icon })
      : _c("span", [_vm._v(_vm._s(_vm.letter))])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aba3dd8", esExports)
  }
}

/***/ }),

/***/ "9Dal":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _entities = __webpack_require__("rMyQ");

var _store3 = __webpack_require__("EBaU");

var _store4 = _interopRequireDefault(_store3);

var _avatar = __webpack_require__("bMMQ");

var _avatar2 = _interopRequireDefault(_avatar);

var _card = __webpack_require__("9KQT");

var _card2 = _interopRequireDefault(_card);

var _iconButton = __webpack_require__("xceO");

var _iconButton2 = _interopRequireDefault(_iconButton);

var _inputSplit = __webpack_require__("P5dX");

var _inputSplit2 = _interopRequireDefault(_inputSplit);

var _modal = __webpack_require__("RpOO");

var _modal2 = _interopRequireDefault(_modal);

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

var _pimpl = __webpack_require__("iS3X");

var _pimpl2 = _interopRequireDefault(_pimpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = function Item(sheeter, sumExpenses) {
	_classCallCheck(this, Item);

	this.sheeter = sheeter;
	this.booker = sheeter.booker;
	this.sumExpenses = sumExpenses;
	this.isMyself = this.booker.isMyself();
};

var Pimpl = function (_ChildrenObserver) {
	_inherits(Pimpl, _ChildrenObserver);

	function Pimpl(component) {
		_classCallCheck(this, Pimpl);

		var _this = _possibleConstructorReturn(this, (Pimpl.__proto__ || Object.getPrototypeOf(Pimpl)).call(this, component.sheet.key));

		_this.component = component;
		return _this;
	}

	_createClass(Pimpl, [{
		key: "resetSplit",
		value: function resetSplit() {
			var component = this.component;
			component.split = component.sheet.cloneSplit() || component.sheet.createSplit();
		}
	}, {
		key: "onAdded",
		value: function onAdded(event, params) {
			var _this2 = this;

			var item = void 0;
			var component = this.component;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = params.entities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var entity = _step.value;

					if (entity.kind === 'Sheeter') {
						item = new Item(entity, 0);
						component.items.unshift(item);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (item) {
				setTimeout(function () {
					_this2.resetSplit();
				}, 0);
			}
		}
	}, {
		key: "onRemoved",
		value: function onRemoved(event, params) {
			if (params.kind === 'Sheeter') {
				var component = this.component,
				    sheetersRemoved = false;

				var _loop = function _loop(id) {
					var index = component.items.findIndex(function (item) {
						return item.sheeter.id === id;
					});
					if (index !== -1) {
						component.items.splice(index, 1);
						sheetersRemoved = true;
					}
				};

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = params.ids[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var id = _step2.value;

						_loop(id);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (sheetersRemoved) {
					this.resetSplit();
				}
			}
		}
	}]);

	return Pimpl;
}(_store.ChildrenObserver);

exports.default = {
	props: {
		sheet: Object,
		anonymousMode: { 'type': Boolean, 'default': false }
	},

	components: {
		Avatar: _avatar2.default,
		InputSplit: _inputSplit2.default,
		Modal: _modal2.default,
		Card: _card2.default
	},

	data: function data() {
		var sheet = this.sheet;
		var items = void 0;
		if (sheet.balance) {
			var balance = sheet.balance.reduce(function (map, balance) {
				map.set(balance.id, balance.value[0]);
				return map;
			}, new Map());
			items = sheet.sheeters.map(function (sheeter) {
				return new Item(sheeter, balance.get(sheeter.booker_id));
			});
		} else {
			items = sheet.sheeters.map(function (sheeter) {
				return new Item(sheeter, 0);
			});
		}

		var shareMode = sheet.share_mode || 0;
		var shareUrl = [location.protocol, '//', location.host, '/share/'];
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = sheet.key.segments()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var segment = _step3.value;

				var keyStr = segment.id.toString(16);
				var keyLenStr = ('0' + keyStr.length).slice(-2);
				shareUrl.push(keyLenStr);
				shareUrl.push(keyStr);
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}

		return {
			p: new _pimpl2.default(new Pimpl(this)),
			savingSheet: false,
			items: items,
			split: this.sheet.id ? this.sheet.cloneSplit() || this.sheet.createSplit() : null,
			name: this.sheet.name,
			editedBooker: null,
			editedBookerName: "",
			renamingBooker: false,
			removingChild: false,
			currency: this.sheet.parent.currency,
			shareMode: shareMode,
			shareEnabled: shareMode > 0,
			shareUrl: shareUrl.join(''),
			savingShare: false
		};
	},


	computed: {
		sortedItems: function sortedItems() {
			return this.items.sort(function (itemA, itemB) {
				return itemA.booker.name.localeCompare(itemB.booker.name);
			});
		},
		cannotSubmit: function cannotSubmit() {
			var canSubmit = !this.savingSheet && Boolean(this.currency);
			if (canSubmit) {
				var split = _entities.HasSplit.copySplit(this.split);
				canSubmit = split === null || split.valid;
			}
			return !canSubmit;
		}
	},

	mounted: function mounted() {
		this.p.impl.register();
	},
	beforeDestroy: function beforeDestroy() {
		this.$refs.modalBookerName.hide();
	},
	destroyed: function destroyed() {
		this.p.impl.unregister();
	},


	methods: {
		saveSheet: function saveSheet() {
			var _this3 = this;

			this.savingSheet = true;
			var afterSave = function afterSave() {
				_this3.savingSheet = false;
			};

			var sheet = this.sheet.clone();
			sheet.name = this.name;
			if (!this.anonymousMode) sheet.share_mode = this.shareMode || 0;
			sheet.assignSplit(this.split);
			if (sheet.split.type === "everybody") {
				sheet.split = null;
			}
			var acknowledge = function acknowledge() {
				_toast2.default.tr('sheet_settings_saved');
			};
			sheet.update().then(function () {
				var book = _this3.sheet.parent;
				if (_this3.currency !== book.currency) {
					var bookClone = book.clone();
					bookClone.currency = _this3.currency;
					bookClone.update().then(afterSave, afterSave).then(acknowledge);
				} else {
					afterSave();
					acknowledge();
				}
			}, afterSave);
		},
		openBookerNameModal: function openBookerNameModal(booker) {
			this.editedBooker = booker.clone();
			this.editedBookerName = booker.name;
			this.$refs.modalBookerName.show();
		},
		applyBookerName: function applyBookerName() {
			var _this4 = this;

			this.renamingBooker = true;
			var afterSave = function afterSave() {
				_this4.renamingBooker = false;
				_this4.$refs.modalBookerName.hide();
			};
			this.editedBooker.name = this.editedBookerName;
			this.editedBooker.update().always(afterSave).then(function () {
				_toast2.default.tr('booker_nameChanged');
			});
		},
		removeSheeter: function removeSheeter(sheeter) {
			var _this5 = this;

			var booker = sheeter.booker;
			if (confirm(this.$formatMessage('sheeter_remove_confirm', { name: booker.name }))) {
				var afterSave = function afterSave() {
					_this5.removingChild = false;
				};
				var promise = sheeter.parent.removeChildren('Sheeter', [sheeter.id], { doNotCatch: true }).catch(function (response) {
					if (response.status === 412) {
						_toast2.default.error(_this5.$formatMessage('sheeter_cannotRemove'));
					} else {
						_toast2.default.error(response.statusText + "<br/>" + response.responseText);
					}
				});
				if (this.anonymousMode) {
					promise.then(function () {
						_this5.sheet.parent.removeChildren('Booker', [booker.id]).then(afterSave, afterSave);
					});
				} else {
					promise.then(afterSave, afterSave);
				}
			}
		},
		openBookersModal: function openBookersModal() {
			this.$refs.modalBookers.show();
		}
	},

	watch: {
		'sheet.split': function sheetSplit() {
			this.p.impl.resetSplit();
		},
		'sheet.share_mode': function sheetShare_mode(shareMode) {
			this.shareEnabled = shareMode > 0;
		},
		'shareEnabled': function shareEnabled() {
			if (Boolean(this.shareMode) != this.shareEnabled) {
				this.shareMode = this.shareEnabled ? 2 : 0;
			}
		}
	}
};

/***/ }),

/***/ "9Ip2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-amount inactive",
      on: {
        "!click": function($event) {
          $event.stopPropagation()
          _vm.focusInput($event)
        }
      }
    },
    [
      _c("div", [
        _vm.value
          ? _c("span", [
              _vm._v(_vm._s(_vm._f("format-currency")(_vm.value, _vm.currency)))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "number",
            required: "",
            step: "any",
            disabled: _vm.disabled
          },
          domProps: { value: _vm.value },
          on: {
            focus: _vm.onInputFocus,
            blur: _vm.onInputBlur,
            input: _vm.onInput
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4d84f0", esExports)
  }
}

/***/ }),

/***/ "9KQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25129c62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/widgets/card.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [_vm._t("footer")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var card = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25129c62", esExports)
  }
}
// CONCATENATED MODULE: ./src/ui/widgets/card.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  card,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\card.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25129c62", Component.options)
  } else {
    hotAPI.reload("data-v-25129c62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var widgets_card = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AGQt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.loading-spacer {\n\tmin-height: 5rem;\n}\n", "", {"version":3,"sources":["C:/Users/fmairess/workspace/lab/wow/vue/src/ui/widgets/src/ui/widgets/loading-spacer.vue"],"names":[],"mappings":";AAKA;CACA,iBAAA;CACA","file":"loading-spacer.vue","sourcesContent":["<template>\r\n\t<div class=\"loading-spacer mt-3 d-flex align-items-center\">{{'loading' | format-message}}</div>\r\n</template>\r\n\r\n<style>\r\n\t.loading-spacer {\r\n\t\tmin-height: 5rem;\r\n\t}\r\n</style>"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "C3wo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Key = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual2 = __webpack_require__("hygk");

var _isEqual3 = _interopRequireDefault(_isEqual2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Key = exports.Key = function () {
	function Key() {
		_classCallCheck(this, Key);

		if (arguments.length === 3) {
			var _arguments = Array.prototype.slice.call(arguments),
			    parent = _arguments[0],
			    kind = _arguments[1],
			    id = _arguments[2];

			if (parent) {
				this.data = Array.from(parent.data);
			} else {
				this.data = [];
			}
			this.data.push(kind, id);
		} else {
			this.data = arguments[0];
		}
	}

	_createClass(Key, [{
		key: 'segments',
		value: function segments() {
			var segments = [];
			for (var i = 0, len = this.data.length; i < len; i += 2) {
				segments.push({ kind: this.data[i], id: this.data[i + 1] });
			}
			return segments;
		}
	}, {
		key: 'toString',
		value: function toString() {
			return this.data.join('-');
		}
	}, {
		key: 'equals',
		value: function equals(key) {
			if (!(key && key.data)) return false;
			return (0, _isEqual3.default)(this.data, key.data);
		}
	}, {
		key: 'kind',
		get: function get() {
			return this.data[this.data.length - 2];
		}
	}, {
		key: 'id',
		get: function get() {
			return this.data[this.data.length - 1];
		}
	}, {
		key: 'parent',
		get: function get() {
			var parent = null;
			if (this.data.length > 2) {
				parent = new Key(this.data.slice(0, -2));
			}
			return parent;
		}
	}, {
		key: 'root',
		get: function get() {
			var root = null;
			if (this.data.length > 2) {
				root = new Key(this.data.slice(0, 2));
			}
			return root;
		}
	}], [{
		key: 'fromString',
		value: function fromString(s) {
			var key = null;
			if (s) {
				key = new Key(s.split('-'));
			}
			return key;
		}
	}]);

	return Key;
}();

/***/ }),

/***/ "CYhj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sheet-page-width mx-auto", attrs: { id: "main" } },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.ajax.sendingCount > 0,
            expression: "ajax.sendingCount > 0"
          }
        ],
        attrs: { id: "ajax-throbber" }
      }),
      _vm._v(" "),
      _c(
        "header",
        {
          staticClass:
            "navbar navbar-dark bg-dark has-title flex-column flex-sm-row align-items-sm-center fixed-top",
          attrs: { id: "header" }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center align-self-start" },
            [
              _c("icon-button", {
                staticClass: "btn-inverse mr-2 btn-back",
                class: _vm.appState.backUrl ? "" : "back-hidden",
                attrs: { name: "arrow-back" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "navbar-brand" }, [
                _c("a", { attrs: { href: "/" } }, [
                  _vm._v(_vm._s(_vm.domainName)),
                  _c("span", { staticClass: "text-muted" }, [_vm._v(".net")])
                ]),
                _vm._v(" "),
                _c("small", [_vm._v(_vm._s(_vm.sheet.name))])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "nav justify-content-between ml-sm-auto" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.settingsTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "settings_title",
                      expression: "'settings_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/settings" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.expensesTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "expenses_title",
                      expression: "'expenses_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/expenses" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.debtsTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "debts_title",
                      expression: "'debts_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/debts" }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.changingState,
            expression: "changingState"
          }
        ],
        staticClass: "overlay"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-131cfa4e", esExports)
  }
}

/***/ }),

/***/ "DZg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.sheet.closed ? "locked" : "",
        "tab-" + _vm.tabState,
        _vm.subState,
        _vm.anonymousMode ? "anonymous" : ""
      ],
      attrs: { id: "wow-sheet" }
    },
    [
      _vm.selection.length > 0
        ? _c(
            "div",
            { staticClass: "toolbar fixed-top d-flex align-items-center px-3" },
            [
              _c("icon-button", {
                staticClass: "mr-2",
                attrs: { name: "close" },
                on: {
                  click: function($event) {
                    _vm.clearSelection()
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$formatMessage("selection-count", {
                      count: _vm.selection.length
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-auto" },
                [
                  _c("icon-button", {
                    attrs: { name: "delete", disabled: _vm.deleting },
                    on: { click: _vm.deleteSelection }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sheet.isOpen
        ? _c(
            "button",
            { staticClass: "btn-fab", on: { click: _vm.showEdit } },
            [_c("i", { staticClass: "icon-add" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }, [
        _c(
          "div",
          { staticClass: "col-left" },
          [
            !_vm.loading
              ? _c("div", [
                  _vm.items.length === 0
                    ? _c("div", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "expenses_void",
                            expression: "'expenses_void'"
                          }
                        ],
                        staticClass: "card card-body"
                      })
                    : _c("button", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_counters_button",
                            expression: "'sheet_counters_button'"
                          }
                        ],
                        staticClass: "btn btn-link balance",
                        on: { click: _vm.showBalance }
                      })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              {
                ref: "rowsList",
                staticClass: "list-group list-transactions",
                class: [_vm.loading ? "mb-0" : ""]
              },
              _vm._l(_vm.items, function(item) {
                return _c(
                  "li",
                  {
                    key: item.row.id,
                    staticClass: "list-group-item",
                    class: [
                      { "bg-selected": item.selected },
                      { "bg-edited": item.edited }
                    ],
                    attrs: { "data-id": item.row.id }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "circle",
                        class: [{ selected: item.selected }]
                      },
                      [
                        item.selected || item.checkboxVisible
                          ? _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: item.selected }
                            })
                          : _c("avatar", { attrs: { booker: item.row.booker } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "amount bg-edited-child bg-selected-child"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm._f("format-currency")(
                                item.row.amount,
                                _vm.currency
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row w-100" }, [
                      _c(
                        "div",
                        {
                          staticClass: "text-truncate col-10",
                          class: item.splitType === "default" ? "" : "col-sm-5"
                        },
                        [
                          _vm._v(
                            _vm._s(item.row.booker.name) + "\n\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4 d-none d-xl-block pl-0" },
                        [
                          _c("expense-split-badge", {
                            staticClass: "my-auto",
                            attrs: { item: item }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-secondary w-100" },
                      [
                        item.row.description
                          ? _c("user-text", {
                              staticClass: "float-left",
                              attrs: { text: item.row.description }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _c("expense-split-badge", {
                              staticClass: "d-xl-none",
                              attrs: { item: item }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-small",
                                attrs: {
                                  title: _vm.$formatMessage("expense_ctime", {
                                    ctime: item.row.ctime
                                  })
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("format-date")(item.row.ctime)
                                  ) + "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            ),
            _vm._v(" "),
            !_vm.allEntitiesLoaded
              ? _c("loading-spacer", { staticClass: "mt-0" })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-right" }, [
          _c(
            "div",
            [
              _c("expense-editor", {
                ref: "expenseEditor",
                attrs: {
                  sheet: _vm.sheet,
                  "row-id": _vm.editedRowId,
                  disabled: _vm.sheet.closed
                },
                on: { cancelled: _vm.onEditCancelled, saved: _vm.onEditSaved }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sheet-balance-wrapper top-header" },
                [
                  _c("sheet-balance", {
                    attrs: {
                      sheetKey: _vm.sheet.key,
                      balance: _vm.sheet.balance,
                      currency: _vm.sheet.parent.currency
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "tabs tabs-up" }, [
                _c("li", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "sheet_edit_tab",
                      expression: "'sheet_edit_tab'"
                    }
                  ],
                  class: { active: _vm.tabState === "edit" },
                  on: {
                    click: function($event) {
                      _vm.showTab("edit")
                    }
                  }
                }),
                _vm._v(" "),
                _c("li", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "sheet_counters_tab",
                      expression: "'sheet_counters_tab'"
                    }
                  ],
                  class: { active: _vm.tabState === "counters" },
                  on: {
                    click: function($event) {
                      _vm.showTab("counters")
                    }
                  }
                })
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e75a60a", esExports)
  }
}

/***/ }),

/***/ "EAHb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBaU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	idToEntity: function idToEntity(entities) {
		return entities.reduce(function (map, entity) {
			return map.set(entity.id, entity);
		}, new Map());
	}
};

/***/ }),

/***/ "Il4e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JHpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "input-split list-unstyled" },
    _vm._l(_vm.sortedSplit, function(item) {
      return _c(
        "li",
        {
          key: item.share.id,
          class: { removed: item.removed },
          attrs: { title: item.title }
        },
        [
          _vm.showCheckbox
            ? _c("div", { staticClass: "form-check" }, [
                _c("label", { staticClass: "form-check-label" }, [
                  _c("input", {
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      checked: "checked",
                      disabled: _vm.disabled
                    },
                    domProps: { checked: item.share.value },
                    on: {
                      change: function($event) {
                        _vm.toggleSplit($event, item.share)
                      }
                    }
                  }),
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.sheet.getBooker(item.share.id).name) +
                      "\n\t\t\t"
                  )
                ])
              ])
            : _c("div", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.sheet.getBooker(item.share.id).name))
              ]),
          _vm._v(" "),
          _c("span", [_vm._v("×")]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: item.share.value,
                  expression: "item.share.value",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                step: "0.1",
                min: "0",
                required: "",
                disabled: _vm.disabled
              },
              domProps: { value: item.share.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(item.share, "value", _vm._n($event.target.value))
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            })
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70940068", esExports)
  }
}

/***/ }),

/***/ "KFRw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ajax = __webpack_require__("gwph");

var _ajax2 = _interopRequireDefault(_ajax);

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

var _iconButton = __webpack_require__("xceO");

var _iconButton2 = _interopRequireDefault(_iconButton);

var _domainName = __webpack_require__("wgEp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		IconButton: _iconButton2.default
	},

	data: function data() {
		return {
			ajax: _ajax2.default,
			sheet: _store2.default.globals.sheet,
			changingState: false,
			appState: _store2.default.globals.appState,
			domainName: (0, _domainName.getDomainName)()
		};
	},

	computed: {
		settingsTabSelected: function settingsTabSelected() {
			return this.$route.path === '/settings';
		},
		expensesTabSelected: function expensesTabSelected() {
			return this.$route.path.indexOf('/expenses') !== -1 || this.sheet.isOpen && this.$route.path === '/';
		},
		debtsTabSelected: function debtsTabSelected() {
			return this.$route.path === '/debts' || this.sheet.closed && this.$route.path === '/';
		}
	},

	methods: {
		toggleSheetState: function toggleSheetState() {
			var _this = this;

			if (this.sheet.isOpen || confirm(this.$formatMessage('sheet_unlock_confirm'))) {
				this.changingState = true;
				var afterSave = function afterSave() {
					_this.changingState = false;
				};
				var sheet = this.sheet.clone();
				sheet.state = Number(!this.sheet.state);
				sheet.update().then(function () {
					_toast2.default.tr(sheet.closed ? 'sheet_lock_saved' : 'sheet_unlock_saved');
				}).then(afterSave, afterSave);
			}
		},
		goBack: function goBack() {
			this.$router.push(_store2.default.globals.appState.backUrl);
		}
	}
};

/***/ }),

/***/ "KsWg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.StoreObserver = exports.ChildrenObserver = exports.Observer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _key = __webpack_require__("C3wo");

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createStore(entityFactory) {
	var Container = function () {
		function Container() {
			_classCallCheck(this, Container);

			this.children = {};
		}

		_createClass(Container, [{
			key: '_getRecord',
			value: function _getRecord(key) {
				var record = this,
				    children = void 0;
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = key.segments()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var segment = _step.value;

						children = record.children[segment.kind];
						if (children) {
							record = children.table[segment.id];
						} else {
							record = null;
						}
						if (!record) {
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				return record;
			}
		}, {
			key: '_ensureChildren',
			value: function _ensureChildren(kind) {
				var children = this.children[kind];
				if (!children) {
					children = {};
					this.children[kind] = children;
				}
				return children;
			}
		}, {
			key: '_ensureTable',
			value: function _ensureTable(kind) {
				var children = this._ensureChildren(kind);
				var table = children.table;
				if (!table) {
					table = {};
					children.table = table;
				}
				return table;
			}
		}, {
			key: '_putRecord',
			value: function _putRecord(kind, rawEntity) {
				if (!rawEntity) throw "Container._putRecord: rawEntity param is invalid";

				var table = this._ensureTable(kind);

				var rawChildren = rawEntity.children;
				if (rawChildren) {
					delete rawEntity.children;
				}

				var entity = entityFactory(this.entity || null, kind, rawEntity);
				var record = table[entity.id],
				    oldEntity = void 0,
				    trueIfCreate = void 0;
				if (record) {
					oldEntity = record.entity.clone();

					var newKeys = new Set(Object.keys(entity));
					for (var p in record.entity) {
						if (record.entity.hasOwnProperty(p) && !newKeys.has(p)) {
							record.entity[p] = null;
						}
					}
					Object.assign(record.entity, entity);
					trueIfCreate = false;
				} else {
					trueIfCreate = true;
					record = new Record(entity);
					table[entity.id] = record;
					oldEntity = null;
				}

				if (rawChildren) {
					for (var _kind in rawChildren) {
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = rawChildren[_kind][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var rawChild = _step2.value;

								record._putRecord(_kind, rawChild);
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				}

				if ('postInit' in record.entity) {
					record.entity.postInit();
				}

				return [trueIfCreate, record, oldEntity];
			}
		}]);

		return Container;
	}();

	var Record = function (_Container) {
		_inherits(Record, _Container);

		function Record(entity) {
			_classCallCheck(this, Record);

			var _this = _possibleConstructorReturn(this, (Record.__proto__ || Object.getPrototypeOf(Record)).call(this));

			_this.entity = entity;
			return _this;
		}

		return Record;
	}(Container);

	var Datastore = function (_Container2) {
		_inherits(Datastore, _Container2);

		function Datastore() {
			_classCallCheck(this, Datastore);

			return _possibleConstructorReturn(this, (Datastore.__proto__ || Object.getPrototypeOf(Datastore)).call(this));
		}

		_createClass(Datastore, [{
			key: 'get',
			value: function get(parentKey, kind, id) {
				var key = void 0;
				if (kind && id) {
					key = new _key.Key(parentKey, kind, id);
				} else {
					key = parentKey;
				}
				var entity = null;
				if (key) {
					var record = this._getRecord(key);
					if (record) {
						entity = record.entity;
					}
				}
				return entity;
			}
		}, {
			key: 'put',
			value: function put(parentKey, kind, rawEntities) {
				var singleResult = void 0;

				if (kind && rawEntities) {
					singleResult = typeof rawEntities[Symbol.iterator] !== 'function';
					if (singleResult) {
						rawEntities = [rawEntities];
					}
				} else {
					singleResult = true;
					var rawEntity = parentKey;
					var key = new _key.Key(rawEntity.key);
					parentKey = key.parent;
					kind = key.kind;
					rawEntities = [rawEntity];
				}
				var parentRecord = parentKey ? this._getRecord(parentKey) : this;

				var result = void 0;
				if (!parentRecord) {
					console.warn('Cannot find parent key: ' + parentKey.toString());
					result = [];
				} else if (rawEntities) {
					parentRecord._ensureTable(kind);
					var entities = [],
					    createdEntities = [],
					    changedEntities = [],
					    trueIfCreate = void 0,
					    record = void 0,
					    oldEntity = void 0;
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = rawEntities[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var _rawEntity = _step3.value;

							var _parentRecord$_putRec = parentRecord._putRecord(kind, _rawEntity);

							var _parentRecord$_putRec2 = _slicedToArray(_parentRecord$_putRec, 3);

							trueIfCreate = _parentRecord$_putRec2[0];
							record = _parentRecord$_putRec2[1];
							oldEntity = _parentRecord$_putRec2[2];

							entities.push(record.entity);
							if (trueIfCreate) {
								createdEntities.push(record.entity);
							} else {
								changedEntities.push({
									oldEntity: oldEntity,
									newEntity: record.entity
								});
							}
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}

					if (createdEntities.length) {
						var event = {
							parent: parentRecord.entity,
							kind: kind,
							entities: createdEntities
						};
						$(this).trigger(kind + '.add', event);
						$(parentRecord).trigger('wow.children.add', event);
					}
					if (changedEntities.length) {
						var _event = {
							parent: parentRecord.entity,
							kind: kind,
							entities: changedEntities
						};
						$(this).trigger(kind + '.update', _event);
						$(parentRecord).trigger('wow.children.update', _event);
					}
					result = entities;
				} else {
					result = [];
				}

				return singleResult && result ? result[0] : result;
			}
		}, {
			key: 'delete',
			value: function _delete(parentKey, kind, ids) {
				var entities = [];
				if (ids && ids.length > 0) {
					var parentRecord = parentKey ? this._getRecord(parentKey) : this;
					var children = parentRecord.children[kind];
					if (children) {
						var table = children.table;
						var record = void 0;
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = ids[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var id = _step4.value;

								record = table[id];
								if (record) {
									entities.push(record.entity);
									delete table[id];
								}
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}

						var event = {
							parent: parentRecord.entity,
							kind: kind,
							ids: ids,
							entities: entities
						};
						$(this).trigger(kind + '.remove', event);
						$(parentRecord).trigger('wow.children.remove', event);
					}
				}
				return entities;
			}
		}, {
			key: '_observeParams',
			value: function _observeParams(parentKeyOrKind, eventType) {
				var eventSource = void 0;
				if (typeof parentKeyOrKind === 'string') {
					eventSource = this;
					eventType = parentKeyOrKind + '.' + eventType;
				} else {
					eventSource = this._getRecord(parentKeyOrKind);
				}
				return [eventSource, eventType];
			}
		}, {
			key: 'observe',
			value: function observe(parentKeyOrKind, eventType, callback) {
				var eventSource = void 0;

				var _observeParams2 = this._observeParams(parentKeyOrKind, eventType);

				var _observeParams3 = _slicedToArray(_observeParams2, 2);

				eventSource = _observeParams3[0];
				eventType = _observeParams3[1];

				$(eventSource).on(eventType, null, null, callback);
			}
		}, {
			key: 'unobserve',
			value: function unobserve(parentKeyOrKind, eventType, callback) {
				var eventSource = void 0;

				var _observeParams4 = this._observeParams(parentKeyOrKind, eventType);

				var _observeParams5 = _slicedToArray(_observeParams4, 2);

				eventSource = _observeParams5[0];
				eventType = _observeParams5[1];

				$(eventSource).off(eventType, callback);
			}
		}, {
			key: 'getByParent',
			value: function getByParent(parentKey, kind, ids) {
				var record = parentKey ? this._getRecord(parentKey) : this;
				var recordChildren = record.children[kind];
				var result = void 0;
				if (recordChildren) {
					var childrenTable = recordChildren.table;
					var childrenIds = ids || Object.keys(childrenTable);
					result = childrenIds.map(function (id) {
						return childrenTable[id].entity;
					});
				} else {
					result = [];
				}
				return result;
			}
		}, {
			key: 'childrenAttr',
			value: function childrenAttr(parentKey, kind, attrName, attrValue) {
				if (attrValue === undefined) {
					attrValue = null;
					var record = this._getRecord(parentKey);
					if (record) {
						var children = this._getRecord(parentKey).children[kind];
						if (children) {
							attrValue = children[attrName];
						}
					}
				} else {
						var _record = this._getRecord(parentKey);
						var _children = _record._ensureChildren(kind);
						_children[attrName] = attrValue;
					}
				return attrValue;
			}
		}]);

		return Datastore;
	}(Container);

	return new Datastore();
}

var Observer = exports.Observer = function () {
	function Observer(eventPrefix, parentKeyOrKind, impl) {
		_classCallCheck(this, Observer);

		this.__eventPrefix = eventPrefix;
		this.__parentKeyOrKind = parentKeyOrKind;
		impl = impl || this;
		if (impl.onAdded) this._onAdded = impl.onAdded.bind(impl);
		if (impl.onRemoved) this._onRemoved = impl.onRemoved.bind(impl);
		if (impl.onUpdated) this._onUpdated = impl.onUpdated.bind(impl);
	}

	_createClass(Observer, [{
		key: 'register',
		value: function register() {
			if (this._onAdded) store.observe(this.__parentKeyOrKind, this.__eventPrefix + '.add', this._onAdded);
			if (this._onRemoved) store.observe(this.__parentKeyOrKind, this.__eventPrefix + '.remove', this._onRemoved);
			if (this._onUpdated) store.observe(this.__parentKeyOrKind, this.__eventPrefix + '.update', this._onUpdated);
		}
	}, {
		key: 'unregister',
		value: function unregister() {
			if (this._onAdded) store.unobserve(this.__parentKeyOrKind, this.__eventPrefix + '.add', this._onAdded);
			if (this._onRemoved) store.unobserve(this.__parentKeyOrKind, this.__eventPrefix + '.remove', this._onRemoved);
			if (this._onUpdated) store.unobserve(this.__parentKeyOrKind, this.__eventPrefix + '.update', this._onUpdated);
		}
	}]);

	return Observer;
}();

var ChildrenObserver = exports.ChildrenObserver = function (_Observer) {
	_inherits(ChildrenObserver, _Observer);

	function ChildrenObserver(parentKey, impl) {
		_classCallCheck(this, ChildrenObserver);

		return _possibleConstructorReturn(this, (ChildrenObserver.__proto__ || Object.getPrototypeOf(ChildrenObserver)).call(this, 'wow.children', parentKey, impl));
	}

	return ChildrenObserver;
}(Observer);

var StoreObserver = exports.StoreObserver = function (_Observer2) {
	_inherits(StoreObserver, _Observer2);

	function StoreObserver(kind, impl) {
		_classCallCheck(this, StoreObserver);

		return _possibleConstructorReturn(this, (StoreObserver.__proto__ || Object.getPrototypeOf(StoreObserver)).call(this, 'wow', kind, impl));
	}

	return StoreObserver;
}(Observer);

var store = void 0;
var globals = {};

exports.default = {
	init: function init(entityFactory) {
		window.__store__ = store = createStore(entityFactory);
		window.__globals__ = globals;
	},
	get: function get(parentKey, kind, id) {
		return store.get(parentKey, kind, id);
	},
	getByParent: function getByParent(parentKey, kind, ids) {
		return store.getByParent(parentKey, kind, ids);
	},
	childrenAttr: function childrenAttr(parentKey, kind, attrName, attrValue) {
		return store.childrenAttr(parentKey, kind, attrName, attrValue);
	},
	put: function put(parentKey, kind, rawEntities) {
		return store.put(parentKey, kind, rawEntities);
	},
	delete: function _delete(parentKey, kind, rawEntities) {
		return store.delete(parentKey, kind, rawEntities);
	},
	observe: function observe(parentKeyOrKind, eventType, callback) {
		return store.observe(parentKeyOrKind, eventType, callback);
	},
	unobserve: function unobserve(parentKeyOrKind, eventType, callback) {
		return store.unobserve(parentKeyOrKind, eventType, callback);
	},

	globals: globals
};

/***/ }),

/***/ "Lv0O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _domainName = __webpack_require__("wgEp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToolbarItem = function ToolbarItem(options) {
	_classCallCheck(this, ToolbarItem);

	Object.assign(this, {
		title: '',
		icon: '',
		method: '',
		className: ''
	}, options);
};

function setToolbar(dest, src) {
	dest.length = 0;
	if (src) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = src[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var item = _step.value;

				dest.push(new ToolbarItem(item));
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}
}

var _class = function () {
	function _class() {
		_classCallCheck(this, _class);

		this.appTitle = (0, _domainName.getDomainName)();
		this.title = null;
		this.toolbar = [];
		this.toolbarMenu = [];
		this.tabs = [];
		this.backUrl = null;
	}

	_createClass(_class, [{
		key: 'setTitle',
		value: function setTitle(title) {
			this.title = title;
			if (title) {
				document.title = title + ' - ' + this.appTitle;
			} else if (title === null) {
				document.title = this.appTitle;
			}
		}
	}, {
		key: 'watchRouter',
		value: function watchRouter(router) {
			var _this = this;

			router.beforeEach(function (to, from, next) {
				var route = {};
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = to.matched[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var matched = _step2.value;

						Object.assign(route, matched.meta);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				_this.setTitle(route.title ? _vue2.default.prototype.$formatMessage(route.title) : route.title);
				_this.backUrl = typeof route.backUrl === 'function' ? route.backUrl(to) : route.backUrl;
				setToolbar(_this.toolbar, route.toolbar);
				setToolbar(_this.toolbarMenu, route.toolbarMenu);

				_this.tabs.length = 0;
				if (route.tabs) {
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = route.tabs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var tab = _step3.value;

							_this.tabs.push(Object.assign({}, tab));
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
				}

				next();
			});
		}
	}]);

	return _class;
}();

exports.default = _class;

/***/ }),

/***/ "NXoF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _sheetExpenses = __webpack_require__("VGZP");

var _sheetExpenses2 = _interopRequireDefault(_sheetExpenses);

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		SheetExpenses: _sheetExpenses2.default
	},
	data: function data() {
		return {
			sheet: _store2.default.globals.sheet
		};
	}
};

/***/ }),

/***/ "OFB5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OsQJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		'name': String
	},

	methods: {
		onClick: function onClick() {
			this.$emit('click');
		}
	}
};

/***/ }),

/***/ "P5dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue__ = __webpack_require__("50/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70940068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_split_vue__ = __webpack_require__("JHpk");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("OFB5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_split_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70940068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_split_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\input-split.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70940068", Component.options)
  } else {
    hotAPI.reload("data-v-70940068", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QGH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.lines, function(line, index) {
      return _c("span", [
        index > 0 ? _c("br") : _vm._e(),
        _vm._v("\n\t\t" + _vm._s(line) + "\n\t")
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e13940", esExports)
  }
}

/***/ }),

/***/ "QM1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "card",
        [
          _c(
            "book-debts",
            { attrs: { book: _vm.sheet } },
            [
              _vm._t("default", [
                _c("div", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "anonymous_nodebts",
                      expression: "'anonymous_nodebts'"
                    }
                  ]
                })
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf0c84a6", esExports)
  }
}

/***/ }),

/***/ "QeCq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = __webpack_require__("4pGR");

var _modal2 = _interopRequireDefault(_modal);

var _pimpl = __webpack_require__("iS3X");

var _pimpl2 = _interopRequireDefault(_pimpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pimpl = function () {
	function Pimpl(component) {
		_classCallCheck(this, Pimpl);

		this.component = component;
		this.modal = null;
		this.hidden = true;
	}

	_createClass(Pimpl, [{
		key: 'show',
		value: function show() {
			var _this = this;

			if (this.hidden) {
				if (!this.modal) {
					var modalElement = this.component.$refs.modal;
					this.modal = new _modal2.default(modalElement);
					$(modalElement).on('shown.bs.modal', function () {
						$(this).find('select:first,input:first,textarea:first').first().focus().select();
					}).on('shown.bs.modal', function () {
						_this.hidden = false;
					}).on('hidden.bs.modal', function () {
						_this.hidden = true;
					});
				}
				$(this.modal._element).appendTo(document.body);
				this.modal.show();
			}
		}
	}, {
		key: 'hide',
		value: function hide() {
			if (!this.hidden) {
				this.modal.hide();
				$(this.modal._element).appendTo(this.component.$el);
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			if (this.modal) {
				this.hide();
				this.modal.dispose();
			}
		}
	}]);

	return Pimpl;
}();

exports.default = {
	props: {
		title: String,
		modalClass: String,
		disabled: { type: Boolean, default: false },
		applyDisabled: { type: Boolean, default: false }
	},

	data: function data() {
		return {
			p: new _pimpl2.default(new Pimpl(this))
		};
	},
	destroyed: function destroyed() {
		this.p.impl.destroy();
	},


	methods: {
		show: function show() {
			this.p.impl.show();
		},
		hide: function hide() {
			this.p.impl.hide();
		},
		apply: function apply() {
			this.$emit('apply');
		}
	}
};

/***/ }),

/***/ "Qs0Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RpOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("QeCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ef877e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("uUBQ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ef877e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-53ef877e", Component.options)
  } else {
    hotAPI.reload("data-v-53ef877e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S4eT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue__ = __webpack_require__("61OL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4d84f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_amout_vue__ = __webpack_require__("9Ip2");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("a0Tp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_amout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4d84f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_amout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\input-amout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f4d84f0", Component.options)
  } else {
    hotAPI.reload("data-v-7f4d84f0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SRvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-icon",
      attrs: { type: "button" },
      on: { click: _vm.onClick }
    },
    [_c("i", { class: "icon-" + _vm.name })]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-589c9497", esExports)
  }
}

/***/ }),

/***/ "SbnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = function Item(booker, balance) {
	_classCallCheck(this, Item);

	this.booker = booker;
	this.balance = balance;
};

function createItems(balance, sheetKey) {
	var items = void 0;
	if (balance) {
		items = balance.map(function (bookerBalance) {
			return new Item(_store2.default.get(sheetKey.parent, 'Booker', bookerBalance.id), bookerBalance.value);
		});
	} else {
		items = _store2.default.getByParent(sheetKey, 'Sheeter').map(function (sheeter) {
			return new Item(sheeter.booker, { value: [0, 0] });
		});
	}
	items.sort(function (a, b) {
		return a.booker.name.localeCompare(b.booker.name);
	});
	return items;
}

function itemsSum(items, index) {
	return items.reduce(function (total, item) {
		total += item.balance[index];
		return total;
	}, 0);
}

exports.default = {
	props: {
		sheetKey: Object,
		balance: Array,
		currency: String
	},

	data: function data() {
		return {
			items: createItems(this.balance, this.sheetKey)
		};
	},


	computed: {
		total: function total() {
			return itemsSum(this.items, 0);
		},
		totalBalance: function totalBalance() {
			return itemsSum(this.items, 1);
		}
	},

	filters: {
		round: function round(value) {
			return value.toFixed(2);
		}
	},

	watch: {
		'balance': function balance() {
			this.items = createItems(this.balance, this.sheetKey);
		}
	}
};

/***/ }),

/***/ "SpH3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ue3Q");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c5e33900", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d645534\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expense-editor.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d645534\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expense-editor.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "UclX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue__ = __webpack_require__("04nl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e13940_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_text_vue__ = __webpack_require__("QGH7");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e13940_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\user-text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07e13940", Component.options)
  } else {
    hotAPI.reload("data-v-07e13940", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VGZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue__ = __webpack_require__("xGv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e75a60a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_expenses_vue__ = __webpack_require__("DZg8");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Il4e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e75a60a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\sheet-expenses.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8e75a60a", Component.options)
  } else {
    hotAPI.reload("data-v-8e75a60a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Vjug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idToBookToClass = new Map();

function getBookerOrder(booker) {
	var bookKey = booker.parentKey;
	var bookId = bookKey.id;
	var bookerIdToClass = idToBookToClass.get(bookId);
	if (!bookerIdToClass) {
		var bookers = _store2.default.getByParent(bookKey, 'Booker').sort(function (a, b) {
			var result = b.ctime - a.ctime;
			if (result === 0) {
				result = b.id - a.id;
			}
			return result;
		});
		bookerIdToClass = new Map();
		var i = 1;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = bookers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _booker = _step.value;

				bookerIdToClass.set(_booker.id, i);
				i += 1;
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		idToBookToClass.set(bookId, bookerIdToClass);
	}
	return bookerIdToClass.get(booker.id);
}

exports.default = {
	props: {
		booker: Object,
		icon: String
	},

	computed: {
		letter: function letter() {
			return this.booker ? this.booker.name.slice(0, 1) : ' ';
		},
		className: function className() {
			return this.booker ? 'avatar-' + (getBookerOrder(this.booker) % 38 + 1) : null;
		}
	}
};

/***/ }),

/***/ "WkD6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = payDebt;

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function payDebt(transactionSolution, component) {
	component.saving = true;
	var afterSave = function afterSave() {
		component.saving = false;
	};
	var book = transactionSolution.book();
	transactionSolution.pay().then(function (event) {
		_toast2.default.cancel(component.$formatMessage('transaction_ackCreate'), function () {
			return book.removeChildren('Transaction', event.created[0].id);
		});
		afterSave();
	}, afterSave);
}

/***/ }),

/***/ "Z/FO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__ = __webpack_require__("NXoF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c582a184_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__ = __webpack_require__("bir4");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vSvM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c582a184_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\apps\\anonymous\\expenses.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c582a184", Component.options)
  } else {
    hotAPI.reload("data-v-c582a184", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "a0Tp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aJcN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = solveDebts;

var _entities = __webpack_require__("rMyQ");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SolutionTransaction = function () {
	function SolutionTransaction(debtor, amount, creditor) {
		_classCallCheck(this, SolutionTransaction);

		this.debtor = debtor;
		this.amount = amount;
		this.creditor = creditor;
	}

	_createClass(SolutionTransaction, [{
		key: 'pay',
		value: function pay() {
			var book = this.book();
			return book.addChildren(new _entities.Transaction(book, {
				creditor_id: this.debtor.id,
				debtor_id: this.creditor.id,
				amount: this.amount,
				origin_entity: book.userBooker().key.data,
				origin_event: 'payback'
			}));
		}
	}, {
		key: 'book',
		value: function book() {
			return this.debtor.parent;
		}
	}, {
		key: 'key',
		value: function key() {
			return '' + this.debtor.key.toString() + this.creditor.key.toString();
		}
	}]);

	return SolutionTransaction;
}();

function compareBalance(b1, b2) {
	return b1.value - b2.value;
}

function solveDebts(balance, bookerProvider) {
	var transactions = [];

	if (balance) {
		var creditors = [],
		    debtors = [];
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = balance[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var bookerBalance = _step.value;

				var value = bookerBalance.value[1];
				if (Math.abs(value) > 0.01) {
					(bookerBalance.value[1] < -0.01 ? debtors : creditors).push({ id: bookerBalance.id, value: bookerBalance.value[1] });
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		if (debtors.length > 0) {
			debtors.sort(compareBalance);
			creditors.sort(compareBalance);

			var indexDebtor = 0,
			    indexCreditor = void 0,
			    debtor = void 0,
			    creditor = void 0,
			    delta = void 0,
			    amount = void 0;
			while (true) {
				debtor = debtors[indexDebtor];
				indexCreditor = 0;
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = creditors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						creditor = _step2.value;

						delta = creditor.value + debtor.value;
						if (delta < 0) {
							break;
						}
						indexCreditor += 1;
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (indexCreditor > 0) {
					indexCreditor -= 1;
					creditor = creditors[indexCreditor];
					delta = creditor.value + debtor.value;
				}

				if (delta < 0) {
					amount = creditor.value;
					debtor.value += amount;
					creditor.value = 0;
				} else {
					amount = -debtor.value;
					debtor.value = 0;
					creditor.value -= amount;
				}

				transactions.push(new SolutionTransaction(bookerProvider.getBooker(debtor.id), amount, bookerProvider.getBooker(creditor.id)));

				if (debtor.value > -0.001) {
					debtors.splice(indexDebtor, 1);
				} else {
					indexDebtor += 1;
				}
				if (creditor.value < 0.001) {
					creditors.splice(indexCreditor, 1);
					creditor = null;
				} else {
					creditors.sort(compareBalance);
				}

				if (indexDebtor >= debtors.length - 1) {
					if (debtors.length === 0 || creditors.length === 0) {
						break;
					}
					indexDebtor = 0;
				}
			}
		}

		transactions.sort(function (t1, t2) {
			return t1.debtor.name.localeCompare(t2.debtor.name);
		});
	}

	return transactions;
}

/***/ }),

/***/ "aNJa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _entities = __webpack_require__("rMyQ");

var _inputSplit = __webpack_require__("P5dX");

var _inputSplit2 = _interopRequireDefault(_inputSplit);

var _inputAmout = __webpack_require__("S4eT");

var _inputAmout2 = _interopRequireDefault(_inputAmout);

var _modal = __webpack_require__("RpOO");

var _modal2 = _interopRequireDefault(_modal);

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

var _pimpl = __webpack_require__("iS3X");

var _pimpl2 = _interopRequireDefault(_pimpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pimpl = function (_ChildrenObserver) {
	_inherits(Pimpl, _ChildrenObserver);

	function Pimpl(component) {
		_classCallCheck(this, Pimpl);

		var _this = _possibleConstructorReturn(this, (Pimpl.__proto__ || Object.getPrototypeOf(Pimpl)).call(this, component.sheet.key));

		_this.component = component;
		return _this;
	}

	_createClass(Pimpl, [{
		key: '_onChanged',
		value: function _onChanged(event, params) {
			if (params.kind === "Sheeter") {
				this.component.reset(true);
			}
		}
	}, {
		key: 'resetEditedSplit',
		value: function resetEditedSplit() {
			var component = this.component;
			component.editedSplit = component.split ? _entities.HasSplit.copySplit(component.split) : component.sheet.createSplit();
		}
	}, {
		key: 'getEditedExpense',
		value: function getEditedExpense(expense) {
			var component = this.component;
			expense.payor_id = component.payorId;
			expense.amount = component.amount;
			expense.description = component.description;
			expense.assignSplit(component.split);
		}
	}, {
		key: 'getSplit',
		value: function getSplit() {
			var component = this.component;
			return component.hasDefaultSplit ? null : _entities.HasSplit.copySplit(component.editedSplit);
		}
	}]);

	return Pimpl;
}(_store.ChildrenObserver);

Pimpl.prototype.onAdded = Pimpl.prototype._onChanged;
Pimpl.prototype.onRemoved = Pimpl.prototype._onChanged;

exports.default = {
	props: {
		'sheet': Object,
		'rowId': Number,
		'disabled': Boolean
	},

	components: {
		InputSplit: _inputSplit2.default,
		InputAmount: _inputAmout2.default,
		Modal: _modal2.default
	},

	data: function data() {
		return {
			p: new _pimpl2.default(new Pimpl(this)),
			split: null,
			hasDefaultSplit: true,
			editedSplit: this.sheet.createSplit(),
			description: "",
			amount: 0,
			payorId: null,
			sending: false,
			disableCancelWhenPristine: true
		};
	},

	computed: {
		sortedBookers: function sortedBookers() {
			return this.sheet.bookers().sort(function (s1, s2) {
				return s1.name.localeCompare(s2.name);
			});
		},
		splitType: function splitType() {
			return this.split ? this.split.type : 'default';
		},
		splitTotalUnits: function splitTotalUnits() {
			return this.split ? this.split.totalUnits : -1;
		},
		splitBookerName: function splitBookerName() {
			return this.split ? this.sheet.getBooker(this.split.bookerId).name : '';
		},
		splitInvalid: function splitInvalid() {
			var split = this.p.impl.getSplit();
			return !(split === null || split.valid);
		},
		cannotCancel: function cannotCancel() {
			return this.disableCancelWhenPristine && this.formPristine || this.sending;
		},
		cannotSubmit: function cannotSubmit() {
			var canSubmit = this.payorId && this.amount > 0 && !this.sending;
			if (canSubmit && this.rowId) {
				var stored = _store2.default.get(this.sheet.key, 'Row', this.rowId);
				var edited = stored.clone();
				this.p.impl.getEditedExpense(edited);
				canSubmit = !stored.equals(edited);
			}
			return !canSubmit;
		},
		formPristine: function formPristine() {
			return !(this.payorId || this.split || this.description || this.amount);
		}
	},

	methods: {
		save: function save() {
			var _this2 = this;

			if (this.cannotSubmit) return;
			this.sending = true;
			var expense = this.rowId ? _store2.default.get(this.sheet.key, 'Row', this.rowId).clone() : new _entities.Row(this.sheet, null);
			this.p.impl.getEditedExpense(expense);
			var resetSending = function resetSending() {
				return _this2.sending = false;
			};
			var saved = function saved(_saved) {
				if (_saved || _saved === undefined) {
					_this2.$emit('saved');
					_toast2.default.tr('expense_saved');
				}
				_this2.focus();
				resetSending();
			};
			if (this.rowId) {
				expense.update().then(function (event) {
					saved(Boolean(event));
				}, resetSending);
			} else {
				this.sheet.addChildren([expense]).then(saved, resetSending);
			}
		},
		cancel: function cancel() {
			this.$emit('cancelled');
			if (!this.rowId) {
				this.reset();
			}
		},
		reset: function reset() {
			var onlySplit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (this.rowId) {
				var expense = _store2.default.get(this.sheet.key, 'Row', this.rowId).clone();
				if (!onlySplit) {
					this.description = expense.description;
					this.amount = expense.amount;
					this.payorId = expense.payor_id;
				}
				this.split = expense.cloneSplit();
			} else {
				if (!onlySplit) {
					this.description = "";
					this.amount = 0;
					this.payorId = null;
				}
				this.split = null;
			}
			this.p.impl.resetEditedSplit();
		},
		toggleSplit: function toggleSplit($event, part) {
			part.value = Number($event.target.checked);
		},
		openSplitModal: function openSplitModal() {
			this.hasDefaultSplit = !this.split;
			this.p.impl.resetEditedSplit();
			this.$refs.splitModal.show();
		},
		applySplit: function applySplit() {
			var split = this.p.impl.getSplit();
			if (split === null || split.valid) {
				this.split = split;
				this.$refs.splitModal.hide();
			}
		},
		focus: function focus() {
			if (this.rowId) {} else {
				$(this.$refs.payorSelect).select().focus();
			}
		}
	},

	watch: {
		'rowId': function rowId() {
			this.reset();
			if (!this.disabled) {
				this.focus();
			}
		}
	},

	mounted: function mounted() {
		var _this3 = this;

		this.p = new _pimpl2.default(new Pimpl(this));
		this.p.impl.register();
		setTimeout(function () {
			_this3.focus();
		}, 0);
	},
	beforeDestroy: function beforeDestroy() {
		this.$refs.splitModal.hide();
	},
	destroyed: function destroyed() {
		this.p.impl.unregister();
	}
};

/***/ }),

/***/ "bMMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__ = __webpack_require__("Vjug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aba3dd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__ = __webpack_require__("6bTo");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("mKfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aba3dd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\avatar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6aba3dd8", Component.options)
  } else {
    hotAPI.reload("data-v-6aba3dd8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bir4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sheet-expenses", {
    staticClass: "container-fluid",
    attrs: { sheet: _vm.sheet, "anonymous-mode": true }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c582a184", esExports)
  }
}

/***/ }),

/***/ "e7Nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue__ = __webpack_require__("yS/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a8970e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_book_debts_vue__ = __webpack_require__("fkpN");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Qs0Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_debts_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a8970e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_book_debts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\book-debts.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09a8970e", Component.options)
  } else {
    hotAPI.reload("data-v-09a8970e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fkpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "book-debts" },
    [
      _vm.items.length
        ? _c("table", { staticClass: "mx-auto" }, [
            _c(
              "tbody",
              _vm._l(_vm.items, function(item) {
                return _c("tr", [
                  _c("td", { staticClass: "text-truncate text-right" }, [
                    _vm._v(_vm._s(item.debtor.name))
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "text-truncate",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$formatMessage("debts_owes", {
                          name: item.creditor.name
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("format-currency")(
                          item.amount,
                          _vm.book.currency
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.payButton
                    ? _c(
                        "td",
                        [
                          _c("icon-button", {
                            attrs: {
                              name: "tick",
                              title: _vm.$formatMessage("debt_payback_tooltip"),
                              disabled: _vm.saving
                            },
                            on: {
                              click: function($event) {
                                _vm.pay(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              })
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("td", { attrs: { colspan: "3" } }, [
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.$formatMessage("debts_when", {
                          date: _vm.$formatDate(_vm.book.mtime)
                        })
                      )
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09a8970e", esExports)
  }
}

/***/ }),

/***/ "gr5a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"settings.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ "gtSB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("j1ja");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _i18n = __webpack_require__("ivlf");

var _i18n2 = _interopRequireDefault(_i18n);

var _jqinit = __webpack_require__("qCIX");

var _settings = __webpack_require__("llF5");

var _settings2 = _interopRequireDefault(_settings);

var _expenses = __webpack_require__("Z/FO");

var _expenses2 = _interopRequireDefault(_expenses);

var _debts = __webpack_require__("/qnk");

var _debts2 = _interopRequireDefault(_debts);

var _app = __webpack_require__("zvLL");

var _app2 = _interopRequireDefault(_app);

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__("1USJ");

var _entities = __webpack_require__("rMyQ");

var _appstate = __webpack_require__("Lv0O");

var _appstate2 = _interopRequireDefault(_appstate);

var _sheetExpensesState = __webpack_require__("xq7v");

var _sheetExpensesState2 = _interopRequireDefault(_sheetExpensesState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

{
	_store2.default.init(_entities.create);
	var data = wow.init_data;
	var book = _store2.default.put(null, 'Book', data.book);
	_store2.default.globals.book = book;
	_store2.default.globals.sheet = _store2.default.put(book.key, 'Sheet', data.sheet);
	delete wow.init_data;

	new _actions.EntityWatcher(book.key).start();
}

_vue2.default.use(_i18n2.default, {
	'language': wow.locale,
	'messages': wow.messages,
	'currency': 'EUR'
});

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
	routes: [{ path: '/settings', component: _settings2.default }, {
		path: '/expenses', component: _expenses2.default,
		children: [{
			path: 'new', name: 'newRow', component: _sheetExpensesState2.default,
			props: { stateName: 'newRow' },
			meta: { backUrl: '/expenses' }
		}, {
			path: 'edit/:rowId', name: 'editRow', component: _sheetExpensesState2.default,
			props: { stateName: 'edit' },
			meta: { backUrl: '/expenses' }
		}, {
			path: 'balance', name: 'balance', component: _sheetExpensesState2.default,
			props: { stateName: 'balance' },
			meta: { backUrl: '/expenses' }
		}]
	}, { path: '/', component: _store2.default.globals.sheet.isOpen ? _expenses2.default : _debts2.default }, { path: '/debts', component: _debts2.default }]
});

var appState = new _appstate2.default();
appState.watchRouter(router);
_store2.default.globals.appState = appState;

var app = new _vue2.default({
	router: router,
	render: function render(h) {
		return h(_app2.default);
	}
}).$mount('#wow-app');

if (!router.currentRoute.matched.length) {
	router.replace('/');
}

(0, _jqinit.init)();

/***/ }),

/***/ "gwph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = {
	sendingCount: 0,
	send: function send(url, method, payloadObject, options) {
		var doNotNotify, doNotCatch;
		if (options) {
			doNotNotify = options.doNotNotify;
			doNotCatch = options.doNotCatch;
		}
		if (!doNotNotify) {
			_module.sendingCount += 1;
		}
		var afterSending = function afterSending() {
			if (!doNotNotify) {
				_module.sendingCount -= 1;
			}
		};
		var promise;
		if (method === 'GET' || method === undefined) {
			promise = $.getJSON(url);
		} else {
			promise = $.ajax(url, {
				data: payloadObject && JSON.stringify(payloadObject) || null,
				method: method
			});
		}
		promise.then(afterSending, function (error) {
			afterSending();
			console.error(error);
			if (!doNotCatch) {
				_toast2.default.error(error.statusText + "<br/>" + error.responseText);
			}
		});
		return promise;
	}
};

exports.default = _module;

/***/ }),

/***/ "hBST":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c010e582", esExports)
  }
}

/***/ }),

/***/ "hn8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "expense-editor",
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.save($event)
        },
        reset: function($event) {
          $event.preventDefault()
          _vm.cancel($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-group" }, [
        _c("label", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "expense_whoPaid",
              expression: "'expense_whoPaid'"
            }
          ],
          staticClass: "form-control-label"
        }),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.payorId,
                expression: "payorId",
                modifiers: { number: true }
              }
            ],
            ref: "payorSelect",
            staticClass: "form-control",
            attrs: { disabled: _vm.disabled },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return _vm._n(val)
                  })
                _vm.payorId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(_vm.sortedBookers, function(booker) {
            return _c(
              "option",
              { key: booker.id, domProps: { value: booker.id } },
              [_vm._v(_vm._s(booker.name) + "\n\t\t\t")]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          { staticClass: "input-split" },
          [
            _c("div", { on: { click: _vm.openSplitModal } }, [
              _c("label", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: "expense_whoPays",
                    expression: "'expense_whoPays'"
                  }
                ],
                staticClass: "form-control-label"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-control",
                  staticStyle: { cursor: "pointer" },
                  attrs: { readonly: _vm.disabled && _vm.formPristine }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$formatMessage("split_type_label", {
                          type: _vm.splitType,
                          totalUnits: _vm.splitTotalUnits,
                          bookerName: _vm.splitBookerName
                        })
                      ) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "modal",
              {
                ref: "splitModal",
                attrs: {
                  "modal-class": "modal-input-split",
                  "apply-disabled": _vm.splitInvalid,
                  title: "expense_input_split_modal_title"
                },
                on: { apply: _vm.applySplit }
              },
              [
                _c("div", { staticClass: "form-check" }, [
                  _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasDefaultSplit,
                          expression: "hasDefaultSplit"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", disabled: _vm.disabled },
                      domProps: {
                        checked: Array.isArray(_vm.hasDefaultSplit)
                          ? _vm._i(_vm.hasDefaultSplit, null) > -1
                          : _vm.hasDefaultSplit
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.hasDefaultSplit,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.hasDefaultSplit = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.hasDefaultSplit = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.hasDefaultSplit = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$formatMessage("expense_split_default")) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("input-split", {
                  attrs: {
                    split: _vm.editedSplit,
                    sheet: _vm.sheet,
                    disabled: _vm.hasDefaultSplit || _vm.disabled
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix visible-sm-up d-md-none" }),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "expense_what",
              expression: "'expense_what'"
            }
          ],
          staticClass: "form-control-label"
        }),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.description,
              expression: "description"
            }
          ],
          staticClass: "form-control",
          attrs: { disabled: _vm.disabled },
          domProps: { value: _vm.description },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.description = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", {
            directives: [
              {
                name: "i18n",
                rawName: "v-i18n",
                value: "expense_howMuch",
                expression: "'expense_howMuch'"
              }
            ],
            staticClass: "form-control-label"
          }),
          _vm._v(" "),
          _c("input-amount", {
            ref: "amountInput",
            attrs: {
              currency: _vm.sheet.parent.currency,
              disabled: _vm.disabled
            },
            model: {
              value: _vm.amount,
              callback: function($$v) {
                _vm.amount = _vm._n($$v)
              },
              expression: "amount"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-right" }, [
        _c("button", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "cancel",
              expression: "'cancel'"
            }
          ],
          staticClass: "btn btn-secondary",
          attrs: { type: "reset", disabled: _vm.cannotCancel }
        }),
        _vm._v(" "),
        !_vm.disabled
          ? _c("button", {
              directives: [
                {
                  name: "i18n",
                  rawName: "v-i18n",
                  value: "save",
                  expression: "'save'"
                }
              ],
              staticClass: "btn btn-primary",
              attrs: { type: "submit", disabled: _vm.cannotSubmit }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d645534", esExports)
  }
}

/***/ }),

/***/ "iS3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __pimpl = Symbol.for('pimpl');

var _class = function () {
	function _class(impl) {
		_classCallCheck(this, _class);

		this[__pimpl] = impl;
	}

	_createClass(_class, [{
		key: 'impl',
		get: function get() {
			return this[__pimpl];
		}
	}]);

	return _class;
}();

exports.default = _class;

/***/ }),

/***/ "ivlf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.init = undefined;

var init = exports.init = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(locale) {
		var langPromise;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						window.IntlRelativeFormat = _intlRelativeformat2.default;
						langPromise = void 0;

						if (locale === 'fr') {
							langPromise = __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Oi0f"));
						} else {
							langPromise = __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "aD1l"));
						}
						return _context.abrupt("return", langPromise);

					case 4:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function init(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _intlMessageformat = __webpack_require__("plEf");

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _intlRelativeformat = __webpack_require__("1Tgx");

var _intlRelativeformat2 = _interopRequireDefault(_intlRelativeformat);

var _intlFormatCache = __webpack_require__("GgGD");

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _isDate = __webpack_require__("LSBV");
var _isString = __webpack_require__("JDN0");
var _isNumber = __webpack_require__("J009");
var _isPlainObject = __webpack_require__("9UkZ");
var _each = __webpack_require__("9uKM");
var _kebabCase = __webpack_require__("Ex7i");
var _clamp = __webpack_require__("RpmR");

function install(Vue, options) {
	var formats = _intlMessageformat2.default.formats;

	var getCachedNumberFormat = (0, _intlFormatCache2.default)(Intl.NumberFormat);
	var getCachedDateTimeFormat = (0, _intlFormatCache2.default)(Intl.DateTimeFormat);
	var getCachedMessageFormat = (0, _intlFormatCache2.default)(_intlMessageformat2.default);
	var getCachedRelativeFormat = (0, _intlFormatCache2.default)(_intlRelativeformat2.default);

	var maximumFractionDigits = 18;

	var language = options.language;
	var currency = options.currency;
	var messages = options.messages;

	var locale = language;

	function formatDate(date, format) {
		var parsedDate = new Date(date);
		if (!_isDate(parsedDate)) throw new TypeError("A date or timestamp must be provided to {{formatDate}}");

		if (_isString(format) && format in formats.date) format = formats.date[format];

		return getCachedDateTimeFormat(locale, format).format(parsedDate);
	}

	function formatTime(date, format) {
		var parsedDate = new Date(date);
		if (!_isDate(date)) throw new TypeError("A date or timestamp must be provided to {{formatTime}}");

		if (_isString(format) && format in formats.time) format = formats.time[format];

		return getCachedDateTimeFormat(locale, format).format(parsedDate);
	}

	function formatNumber(num, format) {
		if (!_isNumber(num)) throw new TypeError("A number must be provided to {{formatNumber}}");

		if (_isString(format)) {
			if (format === "currency") {
				format = {
					style: "currency",
					currency: currency
				};
			} else if (format in formats.number) {
				format = formats.number[format];
			}
		}

		return getCachedNumberFormat(locale, format).format(num);
	}

	function formatRelative(date, format, now) {
		var parsedDate = new Date(date);
		if (!_isDate(parsedDate)) throw new TypeError("A date or timestamp must be provided to {{formatRelative}}");

		return getCachedRelativeFormat(locale, format).format(parsedDate, {
			now: now || new Date()
		});
	}

	function formatCurrency(val, currency) {
		var numberOptions = {
			style: "currency",
			currency: 'EUR',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		};

		var result = formatNumber(!val ? 0 : val, numberOptions);
		return result.replace('€', currency);
	}

	function formatMessage(message) {
		if (message.startsWith('##')) return message.slice(2);
		var _len = arguments.length;
		var formatOptions = Array(_len > 1 ? _len - 1 : 0);
		for (var _key = 1; _key < _len; _key++) {
			formatOptions[_key - 1] = arguments[_key];
		}

		if (message in messages) message = messages[message];

		if (typeof message === "string") message = getCachedMessageFormat(message, locale, {});

		if (formatOptions.length === 1 && _isPlainObject(formatOptions[0])) formatOptions = formatOptions[0];

		return message.format(formatOptions);
	}

	var helpers = {
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatMessage: formatMessage,
		formatCurrency: formatCurrency
	};

	_each(helpers, function (helper, name) {
		Vue.filter(_kebabCase(name), helper);

		Vue.prototype["$" + name] = helper;
	});

	Vue.prototype.$locale = locale;

	Vue.directive("i18n", function (el, binding) {
		el.innerHTML = formatMessage(binding.value);
	});

	Vue.filter("format-currency", function (val, currency) {
		return formatCurrency(val, currency);
	});

	Vue.filter("format-percent", function read(val, fractionDigits) {
		return formatNumber(val == null || val === "" ? 0 : _clamp(val / 100, 0, 1), {
			style: "percent",
			minimumFractionDigits: fractionDigits == null ? 0 : fractionDigits,
			maximumFractionDigits: fractionDigits == null ? maximumFractionDigits : fractionDigits
		});
	});

	Vue.filter("format-number", function read(val, fractionDigits) {
		return val == null || val === "" ? 0 : formatNumber(val, {
			minimumFractionDigits: fractionDigits == null ? 0 : fractionDigits,
			maximumFractionDigits: fractionDigits == null ? maximumFractionDigits : fractionDigits
		});
	});
}

exports.default = {
	install: install
};

/***/ }),

/***/ "ixKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("sheet-settings", {
        attrs: { sheet: _vm.sheet, "anonymous-mode": true },
        on: { addParticipants: _vm.openParticipantsModal }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modalNewParticipant",
          attrs: {
            title: "participants_add_modal_title",
            "modal-class": "modal-bookers",
            disabled: _vm.savingNewParticipants,
            applyDisabled: _vm.newParticipantInvalid
          },
          on: { apply: _vm.saveNewParticipant }
        },
        [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-danger": _vm.duplicateParticipant }
            },
            [
              _c("label", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: "participants_add_name_label",
                    expression: "'participants_add_name_label'"
                  }
                ],
                staticClass: "form-control-label"
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newParticipantName,
                    expression: "newParticipantName"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.newParticipantName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newParticipantName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.duplicateParticipant
                ? _c("div", {
                    directives: [
                      {
                        name: "i18n",
                        rawName: "v-i18n",
                        value: "participants_duplicateName",
                        expression: "'participants_duplicateName'"
                      }
                    ],
                    staticClass: "form-control-feedback"
                  })
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a96446", esExports)
  }
}

/***/ }),

/***/ "jMug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		item: Object
	},
	computed: {
		text: function text() {
			return this.$formatMessage('split_type_label', {
				type: this.item.splitType,
				totalUnits: this.item.splitTotalUnits,
				bookerName: this.item.splitBookerName
			});
		}
	}
};

/***/ }),

/***/ "jP3O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _bookDebts = __webpack_require__("e7Nv");

var _bookDebts2 = _interopRequireDefault(_bookDebts);

var _card = __webpack_require__("9KQT");

var _card2 = _interopRequireDefault(_card);

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		BookDebts: _bookDebts2.default,
		Card: _card2.default
	},

	data: function data() {
		return {
			sheet: _store2.default.globals.sheet
		};
	}
};

/***/ }),

/***/ "jYKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue__ = __webpack_require__("SbnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ee5dac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_balance_vue__ = __webpack_require__("s7At");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("jikz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_balance_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ee5dac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_balance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\sheet-balance.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50ee5dac", Component.options)
  } else {
    hotAPI.reload("data-v-50ee5dac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jikz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jl9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sheet-settings" },
    [
      _c("section", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("form", { attrs: { disabled: _vm.sheet.closed } }, [
            _c("div", { staticClass: "card-body row" }, [
              _c(
                "fieldset",
                {
                  staticClass: "col-md-6",
                  attrs: { disabled: _vm.anonymousMode && _vm.shareEnabled }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", {
                      directives: [
                        {
                          name: "i18n",
                          rawName: "v-i18n",
                          value: "sheet_settings_sheetTitle",
                          expression: "'sheet_settings_sheetTitle'"
                        }
                      ],
                      staticClass: "form-control-label"
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: _vm.sheet.closed },
                      domProps: { value: _vm.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.anonymousMode
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", {
                          directives: [
                            {
                              name: "i18n",
                              rawName: "v-i18n",
                              value: "book_settings_currency",
                              expression: "'book_settings_currency'"
                            }
                          ],
                          staticClass: "form-control-label"
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currency,
                              expression: "currency"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { required: "" },
                          domProps: { value: _vm.currency },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currency = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.anonymousMode
                    ? _c("div", [
                        _c("div", { staticClass: "form-check" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.shareEnabled,
                                  expression: "shareEnabled"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.shareEnabled)
                                  ? _vm._i(_vm.shareEnabled, null) > -1
                                  : _vm.shareEnabled
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.shareEnabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.shareEnabled = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.shareEnabled = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.shareEnabled = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$formatMessage(
                                    "sheet_share_enableSharing"
                                  )
                                ) +
                                "\n\t\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("small", {
                            directives: [
                              {
                                name: "i18n",
                                rawName: "v-i18n",
                                value: "sheet_share_enableSharing_tip",
                                expression: "'sheet_share_enableSharing_tip'"
                              }
                            ],
                            staticClass: "form-text text-muted"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "fieldset",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.shareEnabled,
                                expression: "shareEnabled"
                              }
                            ],
                            attrs: { disabled: !_vm.shareEnabled }
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", {
                                directives: [
                                  {
                                    name: "i18n",
                                    rawName: "v-i18n",
                                    value: "sheet_share_linkSheet",
                                    expression: "'sheet_share_linkSheet'"
                                  }
                                ],
                                attrs: { for: "sheet-share-url" }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.shareUrl,
                                    expression: "shareUrl"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "sheet-share-url",
                                  readonly: "readonly"
                                },
                                domProps: { value: _vm.shareUrl },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.shareUrl = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("small", {
                                directives: [
                                  {
                                    name: "i18n",
                                    rawName: "v-i18n",
                                    value: "sheet_share_linkSheet_tip",
                                    expression: "'sheet_share_linkSheet_tip'"
                                  }
                                ],
                                staticClass: "form-text text-muted"
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.shareMode,
                                      expression: "shareMode"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.shareMode = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", {
                                    directives: [
                                      {
                                        name: "i18n",
                                        rawName: "v-i18n",
                                        value: "sheet_share_mode_view",
                                        expression: "'sheet_share_mode_view'"
                                      }
                                    ],
                                    attrs: { value: "1" }
                                  }),
                                  _vm._v(" "),
                                  _c("option", {
                                    directives: [
                                      {
                                        name: "i18n",
                                        rawName: "v-i18n",
                                        value: "sheet_share_mode_edit",
                                        expression: "'sheet_share_mode_edit'"
                                      }
                                    ],
                                    attrs: { value: "2" }
                                  })
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.split
                ? _c(
                    "fieldset",
                    {
                      staticClass: "col-md-6",
                      attrs: {
                        disabled:
                          (_vm.shareEnabled && _vm.anonymousMode) ||
                          _vm.sheet.closed
                      }
                    },
                    [
                      _c("h4", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_settings_split_title",
                            expression: "'sheet_settings_split_title'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("small", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_settings_split_help",
                            expression: "'sheet_settings_split_help'"
                          }
                        ],
                        staticClass: "form-text text-muted"
                      }),
                      _vm._v(" "),
                      _c("input-split", {
                        attrs: {
                          split: _vm.split,
                          sheet: _vm.sheet,
                          disabled: _vm.sheet.closed,
                          showCheckbox: false
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.sheet.isOpen && !(_vm.shareEnabled && _vm.anonymousMode)
              ? _c("div", { staticClass: "card-footer" }, [
                  _c("button", {
                    directives: [
                      {
                        name: "i18n",
                        rawName: "v-i18n",
                        value: "save",
                        expression: "'save'"
                      }
                    ],
                    staticClass: "card-link",
                    attrs: { type: "button", disabled: _vm.cannotSubmit },
                    on: { click: _vm.saveSheet }
                  })
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.sheet.id && !(_vm.anonymousMode && _vm.shareEnabled)
        ? _c("section", { staticClass: "participants" }, [
            _c("div", { staticClass: "row" }, [
              _c("h3", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: "sheet_settings_sheeters",
                    expression: "'sheet_settings_sheeters'"
                  }
                ],
                staticClass: "col-8"
              }),
              _vm._v(" "),
              !_vm.sheet.closed
                ? _c("div", { staticClass: "col-4 text-right" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "i18n",
                          rawName: "v-i18n",
                          value: "add",
                          expression: "'add'"
                        }
                      ],
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$emit("addParticipants")
                        }
                      }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row margin-top" },
              _vm._l(_vm.sortedItems, function(item) {
                return _c(
                  "div",
                  { key: item.sheeter.id, staticClass: "col-md-6" },
                  [
                    _c(
                      "card",
                      { staticClass: "card-avatar" },
                      [
                        _c("avatar", { attrs: { booker: item.booker } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "col-6 no-margin text-nowrap text-truncate",
                              attrs: { title: item.booker.name }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" + _vm._s(item.booker.name)
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-secondary" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t∑ " +
                                _vm._s(
                                  _vm._f("format-currency")(
                                    item.sumExpenses,
                                    _vm.currency
                                  )
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _vm.anonymousMode
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "card-link",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.openBookerNameModal(item.booker)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("format-message")("rename")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.isMyself
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "card-link",
                                    attrs: {
                                      type: "button",
                                      title:
                                        item.sumExpenses > 0
                                          ? _vm.$formatMessage(
                                              "sheeter_cannotRemove"
                                            )
                                          : "",
                                      disabled:
                                        _vm.sheet.closed ||
                                        item.sumExpenses > 0 ||
                                        _vm.removingChild
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.removeSheeter(item.sheeter)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("format-message")("delete")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modalBookerName",
          attrs: {
            title: "booker_changeName_modal_title",
            "modal-class": "modal-booker-name",
            disabled: _vm.renamingBooker,
            applyDisabled: !_vm.editedBookerName
          },
          on: { apply: _vm.applyBookerName }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editedBookerName,
                expression: "editedBookerName"
              }
            ],
            ref: "inputBookerName",
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.editedBookerName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.editedBookerName = $event.target.value
              }
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7a03bfa", esExports)
  }
}

/***/ }),

/***/ "lg1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad073d48","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/widgets/loading-spacer.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-spacer mt-3 d-flex align-items-center" },
    [_vm._v(_vm._s(_vm._f("format-message")("loading")))]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var loading_spacer = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad073d48", esExports)
  }
}
// CONCATENATED MODULE: ./src/ui/widgets/loading-spacer.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("sTjh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  loading_spacer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\loading-spacer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ad073d48", Component.options)
  } else {
    hotAPI.reload("data-v-ad073d48", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var widgets_loading_spacer = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "llF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__("wrQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a96446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("ixKz");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("sBm6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70a96446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\apps\\anonymous\\settings.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70a96446", Component.options)
  } else {
    hotAPI.reload("data-v-70a96446", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mKfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n0dT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.splitType !== "default"
    ? _c(
        "div",
        {
          staticClass: "badge badge-pill badge-secondary",
          attrs: { title: _vm.text }
        },
        [_vm._v("\n\t" + _vm._s(_vm.text) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bf09f79", esExports)
  }
}

/***/ }),

/***/ "qCIX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.init = init;

__webpack_require__("EWnD");

var _debounce = __webpack_require__("O4Lo");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
	$(function () {

		var $tabs = $('#header').find('ul.navbar-nav'),
		    tabsHeight = $tabs.height(),
		    $window = $(window),
		    $body = $(document.body),
		    mini = false;
		$window.scroll((0, _debounce2.default)(function () {
			var scrollTop = $window.scrollTop();
			if (scrollTop > tabsHeight) {
				if (!mini) {
					$body.toggleClass('header-mini', true);
					mini = true;
				}
			} else if (scrollTop === 0 && mini) {
				$body.toggleClass('header-mini', false);
				mini = false;
			}
		}, 60));

		$(document).on('focus blur', '.form-control', function (e) {
			var $target = $(e.currentTarget);
			$target.closest('.form-group').toggleClass('form-group-focused', $target.is(':focus'));
		});
	});
}

/***/ }),

/***/ "qoia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue__ = __webpack_require__("9Dal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a03bfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_settings_vue__ = __webpack_require__("jl9l");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("CYhj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_settings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a03bfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\sheet-settings.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e7a03bfa", Component.options)
  } else {
    hotAPI.reload("data-v-e7a03bfa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rMyQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.User = exports.Transaction = exports.Row = exports.Sheeter = exports.Sheet = exports.HasSplit = exports.Invitation = exports.Booker = exports.Book = exports.Entity = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.create = create;

var _key = __webpack_require__("C3wo");

var _store2 = __webpack_require__("KsWg");

var _store3 = _interopRequireDefault(_store2);

var _actions = __webpack_require__("1USJ");

var _actions2 = _interopRequireDefault(_actions);

var _remove2 = __webpack_require__("afSG");

var _remove3 = _interopRequireDefault(_remove2);

var _isEqual2 = __webpack_require__("hygk");

var _isEqual3 = _interopRequireDefault(_isEqual2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Loader = function () {
	function Loader(parentKey, kind, observeEventPrefix, limit) {
		var _this = this;

		_classCallCheck(this, Loader);

		this.parentKey = parentKey;
		this.kind = kind;
		this.allLoaded = false;
		this.limit = limit;
		this.loading = false;
		this.iteration = 0;

		if (limit) {
			this.entities = [];
			_store3.default.observe(parentKey || kind, observeEventPrefix + '.add', function (ev, eventParams) {
				if (eventParams.kind === _this.kind) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = eventParams.entities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var child = _step.value;

							if (_this.loading) {
								_this.entities.push(child);
							} else {
								_this.entities.unshift(child);
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				}
			});
			_store3.default.observe(parentKey || kind, observeEventPrefix + '.remove', function (ev, eventParams) {
				if (eventParams.kind === _this.kind) {
					_this._forget(eventParams.entities);
				}
			});
		}
	}

	_createClass(Loader, [{
		key: 'load',
		value: function load(offset) {
			var _this2 = this;

			var promise = void 0,
			    entities = null,
			    loaded = false;

			if (this.limit) {
				if (this.entities.length >= offset + this.limit || this.allLoaded) {
					entities = this.entities.slice(offset, offset + this.limit);
					loaded = true;
				}
			} else if (this.allLoaded) {
				loaded = true;
			}

			if (loaded) {
				promise = Promise.resolve(this.limit ? [entities, offset + this.limit > this.entities.length] : entities);
			} else {
				this.loading = true;
				this.iteration += 1;
				var limit = this.iteration * this.limit;
				promise = this._fetch(limit, offset).then(function (data) {
					var children = _this2._store(data);
					_this2.allLoaded = !_this2.limit || children.length < limit;
					_this2.loading = false;
					return _this2.limit ? [children, _this2.allLoaded] : children;
				});
			}
			return promise;
		}
	}, {
		key: '_fetch',
		value: function _fetch(limit, offset) {
			throw 'Not implemented';
		}
	}, {
		key: '_store',
		value: function _store(rawEntities) {
			return rawEntities.map(function (rawEntity) {
				return _store3.default.put(rawEntity);
			});
		}
	}, {
		key: '_forget',
		value: function _forget(entities) {
			var _this3 = this;

			var _loop = function _loop(entity) {
				var entityKey = entity.key;
				(0, _remove3.default)(_this3.entities, function (entity) {
					return entity.key.equals(entityKey);
				});
			};

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = entities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var entity = _step2.value;

					_loop(entity);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}]);

	return Loader;
}();

var ChildrenLoader = function (_Loader) {
	_inherits(ChildrenLoader, _Loader);

	function ChildrenLoader(parentKey, kind, limit) {
		_classCallCheck(this, ChildrenLoader);

		return _possibleConstructorReturn(this, (ChildrenLoader.__proto__ || Object.getPrototypeOf(ChildrenLoader)).call(this, parentKey, kind, 'wow.children', limit));
	}

	_createClass(ChildrenLoader, [{
		key: '_fetch',
		value: function _fetch(limit, offset) {
			return _actions2.default.get(this.parentKey, this.kind, null, limit, offset, ['-ctime']);
		}
	}, {
		key: '_store',
		value: function _store(rawEntities) {
			return _store3.default.put(this.parentKey, this.kind, rawEntities);
		}
	}, {
		key: '_forget',
		value: function _forget(entities) {
			var _this5 = this;

			var _loop2 = function _loop2(entity) {
				var entityId = entity.id;
				(0, _remove3.default)(_this5.entities, function (entity) {
					return entity.id === entityId;
				});
			};

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = entities[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var entity = _step3.value;

					_loop2(entity);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		}
	}]);

	return ChildrenLoader;
}(Loader);

var Entity = exports.Entity = function () {
	function Entity(parent, data) {
		_classCallCheck(this, Entity);

		this.parentKey = parent ? parent.key || parent : null;

		if (data) {
			var key = data.key;
			if (key) {
				data.id = key[key.length - 1];
				delete data.key;
			}

			if (data.parentKey) {
				delete data.parentKey;
			}

			var dateRegex = /.*(time|date)/;
			for (var prop in data) {
				if (dateRegex.test(prop)) {
					data[prop] = new Date(data[prop]);
				}
			}

			Object.assign(this, data);
		}
	}

	_createClass(Entity, [{
		key: 'clone',
		value: function clone() {
			return new this.__proto__.constructor(this.parent, Object.assign({}, this));
		}
	}, {
		key: 'addChildren',
		value: function addChildren(children) {
			var kind = children instanceof Array ? children[0].kind : children.kind;
			return _actions2.default.post(this.key, kind, children);
		}
	}, {
		key: 'removeChildren',
		value: function removeChildren(kind, ids, options) {
			return _actions2.default.delete(this.key, kind, ids, options);
		}
	}, {
		key: 'loadChild',
		value: function loadChild(kind, id) {
			var promise = void 0;
			var key = this.key;
			var child = _store3.default.get(key, kind, id);
			if (child) {
				promise = Promise.resolve(child);
			} else {
				promise = _actions2.default.get(key, kind, id).then(function (data) {
					return _store3.default.put(key, kind, data);
				});
			}
			return promise;
		}
	}, {
		key: 'loadChildren',
		value: function loadChildren(kind, limit, offset) {
			return this.getLoader(kind, limit).load(offset);
		}
	}, {
		key: 'getLoader',
		value: function getLoader(kind, limit) {
			var key = this.key;
			var loader = _store3.default.childrenAttr(key, kind, 'loader');
			if (loader) {
				if (loader.limit !== limit) throw 'Invalid state';
			} else {
				loader = _store3.default.childrenAttr(key, kind, 'loader', new ChildrenLoader(key, kind, limit));
			}
			return loader;
		}
	}, {
		key: 'update',
		value: function update() {
			var stored = _store3.default.get(this.key).toJSON();
			var promise = void 0;
			if ((0, _isEqual3.default)(stored, this.toJSON())) {
				promise = Promise.resolve(null);
			} else {
				promise = _actions2.default.put(this);
			}
			return promise;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {
			var jentity = Object.assign({}, this);
			delete jentity.parentKey;
			return jentity;
		}
	}, {
		key: 'equals',
		value: function equals(other) {
			return (0, _isEqual3.default)(other, this);
		}
	}, {
		key: 'key',
		get: function get() {
			return new _key.Key(this.parentKey, this.kind, this.id);
		}
	}, {
		key: 'parent',
		get: function get() {
			return _store3.default.get(this.parentKey);
		}
	}]);

	return Entity;
}();

var Book = exports.Book = function (_Entity) {
	_inherits(Book, _Entity);

	function Book(parent, data) {
		_classCallCheck(this, Book);

		return _possibleConstructorReturn(this, (Book.__proto__ || Object.getPrototypeOf(Book)).call(this, parent, data));
	}

	_createClass(Book, [{
		key: 'getBooker',
		value: function getBooker(id) {
			return _store3.default.get(this.key, 'Booker', id);
		}
	}, {
		key: 'deleteInvitation',
		value: function deleteInvitation(invitation) {
			return _actions2.default.delete(this.key, 'Invitation', invitation.id);
		}
	}, {
		key: 'loadUsers',
		value: function loadUsers() {
			var bookers = this.bookers;
			if (bookers.some(function (booker) {
				return booker.user_id && !_store3.default.get(null, 'User', booker.user_id);
			})) {
				return _actions2.default.get(this.key, 'User').then(function (data) {
					_store3.default.put(null, 'User', data);
				}.bind(this));
			}
			return new Promise(function (resolve) {
				resolve();
			});
		}
	}, {
		key: 'userBooker',
		value: function userBooker() {
			var booker = null;
			var userId = _store3.default.globals.user.id;
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = _store3.default.getByParent(this.key, 'Booker')[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var b = _step4.value;

					if (b.user_id === userId) {
						booker = b;
						break;
					}
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			return booker;
		}
	}, {
		key: 'bookers',
		get: function get() {
			return _store3.default.getByParent(this.key, 'Booker');
		}
	}, {
		key: 'invitations',
		get: function get() {
			return _store3.default.getByParent(this.key, 'Invitation');
		}
	}], [{
		key: 'createKey',
		value: function createKey(id) {
			return new _key.Key(['Book', id]);
		}
	}]);

	return Book;
}(Entity);

var Booker = exports.Booker = function (_Entity2) {
	_inherits(Booker, _Entity2);

	function Booker(parent, data) {
		_classCallCheck(this, Booker);

		return _possibleConstructorReturn(this, (Booker.__proto__ || Object.getPrototypeOf(Booker)).call(this, parent, data));
	}

	_createClass(Booker, [{
		key: 'createInvitation',
		value: function createInvitation(email) {
			return _actions2.default.post(this.key, 'Invitation', email);
		}
	}, {
		key: 'isMyself',
		value: function isMyself() {
			var user = _store3.default.globals.user;
			return user && this.user_id === user.id;
		}
	}, {
		key: 'user',
		get: function get() {
			return _store3.default.get(null, 'User', this.user_id);
		}
	}]);

	return Booker;
}(Entity);

var Invitation = exports.Invitation = function (_Entity3) {
	_inherits(Invitation, _Entity3);

	function Invitation(parent, data) {
		_classCallCheck(this, Invitation);

		return _possibleConstructorReturn(this, (Invitation.__proto__ || Object.getPrototypeOf(Invitation)).call(this, parent, data));
	}

	_createClass(Invitation, [{
		key: 'resend',
		value: function resend() {
			return _actions2.default.put(this);
		}
	}]);

	return Invitation;
}(Entity);

var Share = function Share(bookerId, splitValue) {
	_classCallCheck(this, Share);

	this.id = bookerId;
	this.value = splitValue;
};

function defineCachedProperty(properties, name, getter) {
	properties[name] = {
		get: function get() {
			var symbol = Symbol.for(name);
			var value = this[symbol];
			if (value === undefined) {
				value = getter.apply(this, arguments);
				this[symbol] = value;
			}
			return value;
		}
	};
}

var defineSplitProperties = function () {
	var splitProperties = function () {
		var properties = {};

		defineCachedProperty(properties, 'totalUnits', function () {
			var totalUnits = 0;
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = this[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var share = _step5.value;

					totalUnits += share.value;
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			return totalUnits;
		});

		defineCachedProperty(properties, 'type', function () {
			var oneUnits = 0,
			    totalUnits = 0,
			    peopleCount = 0;
			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = this[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var share = _step6.value;

					if (share.value === 1) {
						oneUnits += 1;
					}
					totalUnits += share.value;
					peopleCount += 1;
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}

			var type = "other";
			if (oneUnits === totalUnits) {
				if (totalUnits === peopleCount) {
					type = "everybody";
				} else if (totalUnits === 1) {
					type = "one";
				}
			}
			return type;
		});

		defineCachedProperty(properties, 'bookerId', function () {
			var _iteratorNormalCompletion7 = true;
			var _didIteratorError7 = false;
			var _iteratorError7 = undefined;

			try {
				for (var _iterator7 = this[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
					var share = _step7.value;

					if (share.value) {
						return share.id;
					}
				}
			} catch (err) {
				_didIteratorError7 = true;
				_iteratorError7 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion7 && _iterator7.return) {
						_iterator7.return();
					}
				} finally {
					if (_didIteratorError7) {
						throw _iteratorError7;
					}
				}
			}
		});

		properties['idToShare'] = {
			get: function get() {
				return this.reduce(function (map, share) {
					return map.set(share.id, share.value);
				}, new Map());
			}
		};

		properties['valid'] = {
			get: function get() {
				var sum = 0,
				    valid = true;
				var _iteratorNormalCompletion8 = true;
				var _didIteratorError8 = false;
				var _iteratorError8 = undefined;

				try {
					for (var _iterator8 = this[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
						var share = _step8.value;

						if (typeof share.value === 'number' && share.value >= 0) {
							sum += share.value;
						} else {
							valid = false;
							break;
						}
					}
				} catch (err) {
					_didIteratorError8 = true;
					_iteratorError8 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion8 && _iterator8.return) {
							_iterator8.return();
						}
					} finally {
						if (_didIteratorError8) {
							throw _iteratorError8;
						}
					}
				}

				valid &= sum !== 0;
				return valid;
			}
		};

		return properties;
	}();

	return function (split) {
		Object.defineProperties(split, splitProperties);
	};
}();

var HasSplit = exports.HasSplit = function (_Entity4) {
	_inherits(HasSplit, _Entity4);

	function HasSplit(parent, data) {
		_classCallCheck(this, HasSplit);

		var _this9 = _possibleConstructorReturn(this, (HasSplit.__proto__ || Object.getPrototypeOf(HasSplit)).call(this, parent, data));

		_this9.postInit();
		return _this9;
	}

	_createClass(HasSplit, [{
		key: 'postInit',
		value: function postInit() {
			if (this.split) {
				if (!this.split.type) {
					defineSplitProperties(this.split);
				}
			} else {
				this.split = null;
			}
			return this;
		}
	}, {
		key: 'createSplit',
		value: function createSplit() {
			var split = this.bookers().map(function (booker) {
				return new entities.Share(booker.id, 1);
			});
			defineSplitProperties(split);
			return split;
		}
	}, {
		key: 'cloneSplit',
		value: function cloneSplit() {
			var split = HasSplit.copySplit(this.split);
			if (split) {
				var idToShare = split.idToShare;
				var _iteratorNormalCompletion9 = true;
				var _didIteratorError9 = false;
				var _iteratorError9 = undefined;

				try {
					for (var _iterator9 = this.bookers()[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
						var booker = _step9.value;

						if (!idToShare.has(booker.id)) {
							idToShare.set(booker.id, 0);
						}
					}
				} catch (err) {
					_didIteratorError9 = true;
					_iteratorError9 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion9 && _iterator9.return) {
							_iterator9.return();
						}
					} finally {
						if (_didIteratorError9) {
							throw _iteratorError9;
						}
					}
				}

				if (idToShare.size !== split.length) {
					var newSplit = [];
					var _iteratorNormalCompletion10 = true;
					var _didIteratorError10 = false;
					var _iteratorError10 = undefined;

					try {
						for (var _iterator10 = idToShare[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
							var _ref = _step10.value;

							var _ref2 = _slicedToArray(_ref, 2);

							var id = _ref2[0];
							var value = _ref2[1];

							newSplit.push(new Share(id, value));
						}
					} catch (err) {
						_didIteratorError10 = true;
						_iteratorError10 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion10 && _iterator10.return) {
								_iterator10.return();
							}
						} finally {
							if (_didIteratorError10) {
								throw _iteratorError10;
							}
						}
					}

					split = newSplit;
				}
			}
			return split;
		}
	}, {
		key: 'assignSplit',
		value: function assignSplit(split) {
			this.split = HasSplit.copySplit(split);
		}
	}, {
		key: 'clone',
		value: function clone() {
			var entity = _get(HasSplit.prototype.__proto__ || Object.getPrototypeOf(HasSplit.prototype), 'clone', this).call(this);
			entity.split = this.cloneSplit();
			return entity;
		}
	}], [{
		key: 'copySplit',
		value: function copySplit(split) {
			var copy = void 0;
			if (split) {
				copy = [];
				var _iteratorNormalCompletion11 = true;
				var _didIteratorError11 = false;
				var _iteratorError11 = undefined;

				try {
					for (var _iterator11 = split[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
						var share = _step11.value;

						copy.push(Object.assign({}, share));
					}
				} catch (err) {
					_didIteratorError11 = true;
					_iteratorError11 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion11 && _iterator11.return) {
							_iterator11.return();
						}
					} finally {
						if (_didIteratorError11) {
							throw _iteratorError11;
						}
					}
				}

				defineSplitProperties(copy);
			} else {
				copy = null;
			}
			return copy;
		}
	}]);

	return HasSplit;
}(Entity);

var SheetLoader = function (_Loader2) {
	_inherits(SheetLoader, _Loader2);

	function SheetLoader(limit) {
		_classCallCheck(this, SheetLoader);

		var _this10 = _possibleConstructorReturn(this, (SheetLoader.__proto__ || Object.getPrototypeOf(SheetLoader)).call(this, null, 'Sheet', 'wow', limit));

		_store3.default.observe('Sheet', 'wow.update', function (ev, evParams) {
			if (evParams.kind === _this10.kind) {
				Sheet.sort(_this10.entities);
			}
		});
		return _this10;
	}

	_createClass(SheetLoader, [{
		key: '_fetch',
		value: function _fetch(limit, offset) {
			return _actions2.default.get(null, 'Sheet/mine', null, limit, offset);
		}
	}]);

	return SheetLoader;
}(Loader);

var sheetLoader = null;

var Sheet = exports.Sheet = function (_HasSplit) {
	_inherits(Sheet, _HasSplit);

	function Sheet(parent, data) {
		_classCallCheck(this, Sheet);

		return _possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call(this, parent, Object.assign({
			name: '',
			state: 0
		}, data)));
	}

	_createClass(Sheet, [{
		key: 'bookersIds',
		value: function bookersIds() {
			return this.balance.map(function (balance) {
				return balance.id;
			});
		}
	}, {
		key: 'bookers',
		value: function bookers() {
			return _store3.default.getByParent(this.parentKey, 'Booker', this.bookersIds());
		}
	}, {
		key: 'getBooker',
		value: function getBooker(id) {
			return _store3.default.get(this.parentKey, 'Booker', id);
		}
	}, {
		key: 'rows',
		value: function rows() {
			return _store3.default.getByParent(this.key, 'Row');
		}
	}, {
		key: 'myBooker',
		value: function myBooker() {
			return this.bookers().find(function (b) {
				return b.isMyself();
			});
		}
	}, {
		key: 'load',
		value: function load() {
			var _this12 = this;

			return this.parent.loadChildren('Booker').then(function () {
				return _this12.loadChildren('Sheeter');
			}).then(function () {
				return _this12;
			});
		}
	}, {
		key: 'sheeters',
		get: function get() {
			return _store3.default.getByParent(this.key, 'Sheeter');
		}
	}, {
		key: 'currency',
		get: function get() {
			return this.parent.currency;
		}
	}, {
		key: 'isOpen',
		get: function get() {
			return this.state === 0;
		}
	}, {
		key: 'closed',
		get: function get() {
			return this.state !== 0;
		}
	}], [{
		key: 'getMineLoader',
		value: function getMineLoader() {
			var limit = 10;
			if (sheetLoader) {
				if (sheetLoader.limit !== limit) throw 'Invalid state';
			} else {
				sheetLoader = new SheetLoader(limit);
			}
			return sheetLoader;
		}
	}, {
		key: 'sort',
		value: function sort(sheets) {
			return sheets.sort(function (a, b) {
				var d = a.state - b.state;
				if (d === 0) {
					d = b.mtime - a.mtime;
				}
				return d;
			});
		}
	}]);

	return Sheet;
}(HasSplit);

var openSheetsLoaded = false;

var Sheeter = exports.Sheeter = function (_Entity5) {
	_inherits(Sheeter, _Entity5);

	function Sheeter(parent, data) {
		_classCallCheck(this, Sheeter);

		return _possibleConstructorReturn(this, (Sheeter.__proto__ || Object.getPrototypeOf(Sheeter)).call(this, parent, data));
	}

	_createClass(Sheeter, [{
		key: 'booker',
		get: function get() {
			return _store3.default.get(this.parentKey.parent, 'Booker', this.booker_id);
		}
	}]);

	return Sheeter;
}(Entity);

var Row = exports.Row = function (_HasSplit2) {
	_inherits(Row, _HasSplit2);

	function Row(parent, data) {
		_classCallCheck(this, Row);

		var _this14 = _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).call(this, parent, data));

		if (!_this14.amount) {
			_this14.amount = 0;
		}
		return _this14;
	}

	_createClass(Row, [{
		key: 'getBooker',
		value: function getBooker(id) {
			return _store3.default.get(this.parentKey.parent, 'Booker', id);
		}
	}, {
		key: 'bookers',
		value: function bookers() {
			return this.parent.bookers();
		}
	}, {
		key: 'payorId',
		get: function get() {
			return this.payor_id;
		},
		set: function set(payorId) {
			this.payor_id = Number(payorId);
		}
	}, {
		key: 'booker',
		get: function get() {
			return this.getBooker(this.payor_id);
		}
	}]);

	return Row;
}(HasSplit);

var Transaction = exports.Transaction = function (_Entity6) {
	_inherits(Transaction, _Entity6);

	function Transaction() {
		_classCallCheck(this, Transaction);

		return _possibleConstructorReturn(this, (Transaction.__proto__ || Object.getPrototypeOf(Transaction)).apply(this, arguments));
	}

	_createClass(Transaction, [{
		key: 'originKey',
		value: function originKey() {
			return this.origin_entity ? new _key.Key(this.origin_entity) : null;
		}
	}, {
		key: 'debtorBooker',
		value: function debtorBooker() {
			return _store3.default.get(this.parentKey, 'Booker', this.debtor_id);
		}
	}, {
		key: 'creditorBooker',
		value: function creditorBooker() {
			return _store3.default.get(this.parentKey, 'Booker', this.creditor_id);
		}
	}, {
		key: 'isFromSheet',
		value: function isFromSheet() {
			var originEvent = this.origin_event;
			return originEvent === 'close' || originEvent === 'open';
		}
	}, {
		key: 'isPayback',
		value: function isPayback() {
			return this.origin_event === 'payback';
		}
	}]);

	return Transaction;
}(Entity);

var User = exports.User = function (_Entity7) {
	_inherits(User, _Entity7);

	function User() {
		_classCallCheck(this, User);

		return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
	}

	return User;
}(Entity);

var entities = {
	User: User, Book: Book, Booker: Booker, Invitation: Invitation, Sheet: Sheet, Sheeter: Sheeter, Row: Row, Share: Share, Transaction: Transaction
};

var _iteratorNormalCompletion12 = true;
var _didIteratorError12 = false;
var _iteratorError12 = undefined;

try {
	for (var _iterator12 = Object.keys(entities)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
		var kind = _step12.value;

		entities[kind].prototype.kind = kind;
	}
} catch (err) {
	_didIteratorError12 = true;
	_iteratorError12 = err;
} finally {
	try {
		if (!_iteratorNormalCompletion12 && _iterator12.return) {
			_iterator12.return();
		}
	} finally {
		if (_didIteratorError12) {
			throw _iteratorError12;
		}
	}
}

function create(parentKey, kind, data) {
	return new entities[kind](parentKey, data);
}

/***/ }),

/***/ "s7At":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table sheet-balance" }, [
    _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_total",
              expression: "'sheet_total'"
            }
          ]
        }),
        _vm._v(" "),
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_balance",
              expression: "'sheet_balance'"
            }
          ]
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.items, function(item) {
        return _c("tr", { key: item.booker.id }, [
          _c(
            "th",
            { staticClass: "text-nowrap", attrs: { title: item.booker.name } },
            [_vm._v(_vm._s(item.booker.name))]
          ),
          _vm._v(" "),
          _c("td", { staticClass: "text-right text-nowrap" }, [
            _vm._v(
              _vm._s(_vm._f("format-currency")(item.balance[0], _vm.currency))
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass: "text-right text-nowrap",
              class: {
                "number-positive": item.balance[1] > 0,
                "number-negative": item.balance[1] < 0
              }
            },
            [
              _vm._v(
                _vm._s(_vm._f("format-currency")(item.balance[1], _vm.currency))
              )
            ]
          )
        ])
      })
    ),
    _vm._v(" "),
    _c("tfoot", [
      _c("tr", [
        _c("th", {
          directives: [
            {
              name: "i18n",
              rawName: "v-i18n",
              value: "sheet_total",
              expression: "'sheet_total'"
            }
          ]
        }),
        _vm._v(" "),
        _c("td", { staticClass: "text-right text-nowrap" }, [
          _vm._v(_vm._s(_vm._f("format-currency")(_vm.total, _vm.currency)))
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "text-right text-nowrap" }, [
          _vm._v(
            _vm._s(_vm._f("format-currency")(_vm.totalBalance, _vm.currency))
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50ee5dac", esExports)
  }
}

/***/ }),

/***/ "sBm6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gr5a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("07ba5a88", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70a96446\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./settings.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70a96446\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./settings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sTjh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AGQt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6dc2f306", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad073d48\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading-spacer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad073d48\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading-spacer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tCWq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});


function enter(vm, to) {
	vm.$parent.$emit('enterState', to.name, to.params);
}

exports.default = {
	name: "sheet-expenses-state",
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		next(function (vm) {
			enter(vm, to);
		});
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		enter(this, to);
		next();
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		this.$parent.$emit('exitState', from.name);
		next();
	}
};

/***/ }),

/***/ "thiv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"expenses.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ "uUBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "modal", staticClass: "modal", class: [_vm.modalClass] }, [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c(
          "form",
          {
            staticClass: "modal-content",
            attrs: { disabled: _vm.disabled || _vm.applyDisabled },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.apply($event)
              }
            }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", {
                directives: [
                  {
                    name: "i18n",
                    rawName: "v-i18n",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                staticClass: "modal-title"
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: { click: _vm.hide }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm._t("modal-footer"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: { click: _vm.hide }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm._f("format-message")("cancel")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link",
                    attrs: {
                      type: "submit",
                      disabled: _vm.disabled || _vm.applyDisabled
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm._f("format-message")("ok")) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                )
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53ef877e", esExports)
  }
}

/***/ }),

/***/ "uZNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue__ = __webpack_require__("aNJa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d645534_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_editor_vue__ = __webpack_require__("hn8W");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("SpH3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d645534_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\expense-editor.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d645534", Component.options)
  } else {
    hotAPI.reload("data-v-2d645534", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ue3Q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.modal-input-split .modal-content {\n\tmax-width: 20rem;\n\tmargin: 0 auto;\n}\n", "", {"version":3,"sources":["C:/Users/fmairess/workspace/lab/wow/vue/src/ui/src/ui/expense-editor.vue"],"names":[],"mappings":";AAsRA;CACA,iBAAA;CACA,eAAA;CACA","file":"expense-editor.vue","sourcesContent":["<template>\r\n\t<form @submit.prevent=\"save\" @reset.prevent=\"cancel\" class=\"expense-editor\">\r\n\t\t<!-- Who paid -->\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label v-i18n=\"'expense_whoPaid'\" class=\"form-control-label\"></label>\r\n\t\t\t<select v-model.number=\"payorId\" class=\"form-control\"\r\n\t\t\t        ref=\"payorSelect\" :disabled=\"disabled\">\r\n\t\t\t\t<option v-for=\"booker of sortedBookers\" :value=\"booker.id\" :key=\"booker.id\">{{booker.name}}\r\n\t\t\t\t</option>\r\n\t\t\t</select>\r\n\t\t</div>\r\n\r\n\t\t<!-- Who pays -->\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<div class=\"input-split\">\r\n\t\t\t\t<!-- Split label -->\r\n\t\t\t\t<div @click=\"openSplitModal\">\r\n\t\t\t\t\t<label v-i18n=\"'expense_whoPays'\" class=\"form-control-label\"></label>\r\n\t\t\t\t\t<div class=\"form-control\" style=\"cursor:pointer\" :readonly=\"disabled && formPristine\">\r\n\t\t\t\t\t\t{{$formatMessage('split_type_label', {type: splitType, totalUnits: splitTotalUnits, bookerName:\r\n\t\t\t\t\t\tsplitBookerName})}}\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<!-- Split modal -->\r\n\t\t\t\t<modal modal-class=\"modal-input-split\" v-on:apply=\"applySplit\" :apply-disabled=\"splitInvalid\"\r\n\t\t\t\t       ref=\"splitModal\" title=\"expense_input_split_modal_title\">\r\n\t\t\t\t\t<div class=\"form-check\">\r\n\t\t\t\t\t\t<label class=\"form-check-label\">\r\n\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"hasDefaultSplit\" class=\"form-check-input\"\r\n\t\t\t\t\t\t\t       :disabled=\"disabled\"/>\r\n\t\t\t\t\t\t\t{{$formatMessage('expense_split_default')}}\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<input-split :split=\"editedSplit\" :sheet=\"sheet\"\r\n\t\t\t\t\t             :disabled=\"hasDefaultSplit || disabled\"></input-split>\r\n\t\t\t\t</modal>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"clearfix visible-sm-up d-md-none\"></div>\r\n\r\n\t\t<!-- What -->\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label v-i18n=\"'expense_what'\" class=\"form-control-label\"></label>\r\n\t\t\t<textarea v-model=\"description\" class=\"form-control\"\r\n\t\t\t          :disabled=\"disabled\"></textarea>\r\n\t\t</div>\r\n\r\n\t\t<!-- How much -->\r\n\t\t<div class=\"form-group\">\r\n\t\t\t<label v-i18n=\"'expense_howMuch'\" class=\"form-control-label\"></label>\r\n\t\t\t<input-amount v-model.number=\"amount\" :currency=\"sheet.parent.currency\"\r\n\t\t\t              ref=\"amountInput\" :disabled=\"disabled\"></input-amount>\r\n\t\t</div>\r\n\r\n\t\t<!-- Buttons -->\r\n\t\t<div class=\"text-right\">\r\n\t\t\t<button class=\"btn btn-secondary\" v-i18n=\"'cancel'\" type=\"reset\"\r\n\t\t\t        :disabled=\"cannotCancel\"></button>\r\n\t\t\t<button class=\"btn btn-primary\" v-i18n=\"'save'\" type=\"submit\" :disabled=\"cannotSubmit\"\r\n\t\t\t        v-if=\"!disabled\"></button>\r\n\t\t</div>\r\n\t</form>\r\n</template>\r\n\r\n<script>\r\n\timport store, {ChildrenObserver} from \"../core/store\";\r\n\timport {Row, HasSplit} from '../core/entities';\r\n\timport InputSplit from './widgets/input-split.vue';\r\n\timport InputAmount from './widgets/input-amout.vue';\r\n\timport Modal from './widgets/modal.vue';\r\n\timport toast from \"./toast\";\r\n\timport PimplWrapper from \"../utils/pimpl\";\r\n\r\n\r\n\tclass Pimpl extends ChildrenObserver {\r\n\t\tconstructor(component) {\r\n\t\t\tsuper(component.sheet.key);\r\n\t\t\tthis.component = component;\r\n\t\t}\r\n\r\n\t\t_onChanged(event, params) {\r\n\t\t\tif (params.kind === \"Sheeter\") {\r\n\t\t\t\tthis.component.reset(true);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tresetEditedSplit() {\r\n\t\t\tconst component = this.component;\r\n\t\t\tcomponent.editedSplit = component.split ?\r\n\t\t\t\tHasSplit.copySplit(component.split) :\r\n\t\t\t\tcomponent.sheet.createSplit();\r\n\t\t}\r\n\r\n\t\tgetEditedExpense(expense) {\r\n\t\t\tconst component = this.component;\r\n\t\t\texpense.payor_id = component.payorId;\r\n\t\t\texpense.amount = component.amount;\r\n\t\t\texpense.description = component.description;\r\n\t\t\texpense.assignSplit(component.split);\r\n\t\t}\r\n\r\n\t\tgetSplit() {\r\n\t\t\tconst component = this.component;\r\n\t\t\treturn component.hasDefaultSplit ? null : HasSplit.copySplit(component.editedSplit);\r\n\t\t}\r\n\t}\r\n\r\n\tPimpl.prototype.onAdded = Pimpl.prototype._onChanged;\r\n\tPimpl.prototype.onRemoved = Pimpl.prototype._onChanged;\r\n\r\n\texport default {\r\n\t\tprops: {\r\n\t\t\t'sheet': Object,\r\n\t\t\t'rowId': Number,\r\n\t\t\t'disabled': Boolean\r\n\t\t},\r\n\r\n\t\tcomponents: {\r\n\t\t\tInputSplit,\r\n\t\t\tInputAmount,\r\n\t\t\tModal\r\n\t\t},\r\n\r\n\t\tdata: function () {\r\n\t\t\treturn {\r\n\t\t\t\tp: new PimplWrapper(new Pimpl(this)),\r\n\t\t\t\tsplit: null,\r\n\t\t\t\thasDefaultSplit: true,\r\n\t\t\t\teditedSplit: this.sheet.createSplit(),\r\n\t\t\t\tdescription: \"\",\r\n\t\t\t\tamount: 0,\r\n\t\t\t\tpayorId: null,\r\n\t\t\t\tsending: false,\r\n\t\t\t\tdisableCancelWhenPristine: true\r\n\t\t\t};\r\n\t\t},\r\n\r\n\t\tcomputed: {\r\n\t\t\tsortedBookers() {\r\n\t\t\t\treturn this.sheet.bookers().sort((s1, s2) => s1.name.localeCompare(s2.name));\r\n\t\t\t},\r\n\t\t\tsplitType() {\r\n\t\t\t\treturn this.split ? this.split.type : 'default';\r\n\t\t\t},\r\n\t\t\tsplitTotalUnits() {\r\n\t\t\t\treturn this.split ? this.split.totalUnits : -1;\r\n\t\t\t},\r\n\t\t\tsplitBookerName() {\r\n\t\t\t\treturn this.split ? this.sheet.getBooker(this.split.bookerId).name : '';\r\n\t\t\t},\r\n\t\t\tsplitInvalid() {\r\n\t\t\t\tconst split = this.p.impl.getSplit();\r\n\t\t\t\treturn !(split === null || split.valid);\r\n\t\t\t},\r\n\t\t\tcannotCancel() {\r\n\t\t\t\treturn this.disableCancelWhenPristine && this.formPristine || this.sending;\r\n\t\t\t},\r\n\t\t\tcannotSubmit() {\r\n\t\t\t\tlet canSubmit = this.payorId && this.amount > 0 && !this.sending;\r\n\t\t\t\tif (canSubmit && this.rowId) {\r\n\t\t\t\t\tconst stored = store.get(this.sheet.key, 'Row', this.rowId);\r\n\t\t\t\t\tconst edited = stored.clone();\r\n\t\t\t\t\tthis.p.impl.getEditedExpense(edited);\r\n\t\t\t\t\tcanSubmit = !stored.equals(edited);\r\n\t\t\t\t}\r\n\t\t\t\treturn !canSubmit;\r\n\t\t\t},\r\n\t\t\tformPristine() {\r\n\t\t\t\treturn !(this.payorId || this.split || this.description || this.amount);\r\n\t\t\t}\r\n\t\t},\r\n\r\n\t\tmethods: {\r\n\t\t\tsave() {\r\n\t\t\t\tif (this.cannotSubmit) // may happen when hitting enter on IE\r\n\t\t\t\t\treturn;\r\n\t\t\t\tthis.sending = true;\r\n\t\t\t\tconst expense = this.rowId ?\r\n\t\t\t\t\tstore.get(this.sheet.key, 'Row', this.rowId).clone() :\r\n\t\t\t\t\tnew Row(this.sheet, null);\r\n\t\t\t\tthis.p.impl.getEditedExpense(expense);\r\n\t\t\t\tlet resetSending = () => this.sending = false;\r\n\t\t\t\tlet saved = (saved) => {\r\n\t\t\t\t\tif (saved || saved === undefined) {\r\n\t\t\t\t\t\tthis.$emit('saved');\r\n\t\t\t\t\t\ttoast.tr('expense_saved');\r\n\t\t\t\t\t}\r\n\t\t\t\t\tthis.focus();\r\n\t\t\t\t\tresetSending();\r\n\t\t\t\t};\r\n\t\t\t\tif (this.rowId) {\r\n\t\t\t\t\texpense.update().then((event) => {\r\n\t\t\t\t\t\tsaved(Boolean(event))\r\n\t\t\t\t\t}, resetSending);\r\n\t\t\t\t} else {\r\n\t\t\t\t\tthis.sheet.addChildren([expense]).then(saved, resetSending);\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tcancel() {\r\n\t\t\t\tthis.$emit('cancelled');\r\n\t\t\t\tif (!this.rowId) {\r\n\t\t\t\t\tthis.reset();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\treset(onlySplit = false) {\r\n\t\t\t\tif (this.rowId) {\r\n\t\t\t\t\tlet expense = store.get(this.sheet.key, 'Row', this.rowId).clone();\r\n\t\t\t\t\tif (!onlySplit) {\r\n\t\t\t\t\t\tthis.description = expense.description;\r\n\t\t\t\t\t\tthis.amount = expense.amount;\r\n\t\t\t\t\t\tthis.payorId = expense.payor_id;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tthis.split = expense.cloneSplit();\r\n\t\t\t\t} else {\r\n\t\t\t\t\tif (!onlySplit) {\r\n\t\t\t\t\t\tthis.description = \"\";\r\n\t\t\t\t\t\tthis.amount = 0;\r\n\t\t\t\t\t\tthis.payorId = null;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tthis.split = null;\r\n\t\t\t\t}\r\n\t\t\t\tthis.p.impl.resetEditedSplit();\r\n\t\t\t},\r\n\t\t\ttoggleSplit($event, part) {\r\n\t\t\t\tpart.value = Number($event.target.checked)\r\n\t\t\t},\r\n\t\t\topenSplitModal() {\r\n\t\t\t\tthis.hasDefaultSplit = !this.split;\r\n\t\t\t\tthis.p.impl.resetEditedSplit();\r\n\t\t\t\tthis.$refs.splitModal.show();\r\n\t\t\t},\r\n\t\t\tapplySplit() {\r\n\t\t\t\tlet split = this.p.impl.getSplit();\r\n\t\t\t\tif (split === null || split.valid) {\r\n\t\t\t\t\tthis.split = split;\r\n\t\t\t\t\tthis.$refs.splitModal.hide();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tfocus() {\r\n\t\t\t\tif (this.rowId) {\r\n\t\t\t\t\t// Do not set focus automatically: annoying on mobile\r\n\t\t\t\t\t// if I don't want to edit this field (shows the keyboard)\r\n\t\t\t\t\t//this.$refs.amountInput.focusInput();\r\n\t\t\t\t} else {\r\n\t\t\t\t\t$(this.$refs.payorSelect).select().focus();\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t},\r\n\r\n\t\twatch: {\r\n\t\t\t'rowId': function () {\r\n\t\t\t\tthis.reset();\r\n\t\t\t\tif (!this.disabled) {\r\n\t\t\t\t\tthis.focus();\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t},\r\n\r\n\t\tmounted() {\r\n\t\t\tthis.p = new PimplWrapper(new Pimpl(this));\r\n\t\t\tthis.p.impl.register();\r\n\t\t\tsetTimeout(() => {\r\n\t\t\t\tthis.focus()\r\n\t\t\t}, 0);\r\n\t\t},\r\n\r\n\t\tbeforeDestroy() {\r\n\t\t\tthis.$refs.splitModal.hide();\r\n\t\t},\r\n\r\n\t\tdestroyed() {\r\n\t\t\tthis.p.impl.unregister();\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n\t.modal-input-split .modal-content {\r\n\t\tmax-width: 20rem;\r\n\t\tmargin: 0 auto;\r\n\t}\r\n</style>"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "vSvM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("thiv");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b8ea0582", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c582a184\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expenses.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c582a184\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expenses.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wgEp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getDomainName = getDomainName;
function getDomainName() {
	return location.host.replace('www.', '').replace('.net', '');
}

/***/ }),

/***/ "wrQK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _sheetSettings = __webpack_require__("qoia");

var _sheetSettings2 = _interopRequireDefault(_sheetSettings);

var _modal = __webpack_require__("RpOO");

var _modal2 = _interopRequireDefault(_modal);

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _entities = __webpack_require__("rMyQ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		SheetSettings: _sheetSettings2.default,
		Modal: _modal2.default
	},

	data: function data() {
		return {
			sheet: _store2.default.globals.sheet,
			newParticipantName: "",
			savingNewParticipants: false,
			bookersNames: new Set(_store2.default.globals.sheet.parent.bookers.map(function (booker) {
				return booker.name.toLowerCase();
			}))
		};
	},


	computed: {
		duplicateParticipant: function duplicateParticipant() {
			return this.newParticipantName && this.bookersNames.has(this.newParticipantName.trim().toLocaleLowerCase());
		},
		newParticipantInvalid: function newParticipantInvalid() {
			return !this.newParticipantName || this.duplicateParticipant;
		},
		anonymousMode: function anonymousMode() {
			return sheet.share_mode > 0 || sheet.parent().password;
		}
	},

	methods: {
		openParticipantsModal: function openParticipantsModal() {
			this.newParticipantName = "";
			this.$refs.modalNewParticipant.show();
		},
		saveNewParticipant: function saveNewParticipant() {
			var _this = this;

			this.savingNewParticipants = true;
			var afterSave = function afterSave() {
				_this.savingNewParticipants = false;
			};
			var book = this.sheet.parent;
			book.addChildren([{ kind: 'Booker', name: this.newParticipantName }]).then(function (event) {
				var bookerId = event.created[0].id;
				_this.sheet.addChildren([{ kind: 'Sheeter', booker_id: bookerId }]).then(function () {
					_this.$refs.modalNewParticipant.hide();
				}).then(afterSave, afterSave);
			}, afterSave);
		}
	}
};

/***/ }),

/***/ "xGv3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__("KsWg");

var _store2 = _interopRequireDefault(_store);

var _expenseEditor = __webpack_require__("uZNj");

var _expenseEditor2 = _interopRequireDefault(_expenseEditor);

var _sheetBalance = __webpack_require__("jYKb");

var _sheetBalance2 = _interopRequireDefault(_sheetBalance);

var _avatar = __webpack_require__("bMMQ");

var _avatar2 = _interopRequireDefault(_avatar);

var _iconButton = __webpack_require__("xceO");

var _iconButton2 = _interopRequireDefault(_iconButton);

var _userText = __webpack_require__("UclX");

var _userText2 = _interopRequireDefault(_userText);

var _toast = __webpack_require__("14kM");

var _toast2 = _interopRequireDefault(_toast);

var _expenseSplitBadge = __webpack_require__("+nvk");

var _expenseSplitBadge2 = _interopRequireDefault(_expenseSplitBadge);

var _pimpl = __webpack_require__("iS3X");

var _pimpl2 = _interopRequireDefault(_pimpl);

var _listfeed = __webpack_require__("yn6c");

var _listfeed2 = _interopRequireDefault(_listfeed);

var _loadingSpacer = __webpack_require__("lg1J");

var _loadingSpacer2 = _interopRequireDefault(_loadingSpacer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = function () {
	function Item(row) {
		_classCallCheck(this, Item);

		this.row = row;
		this.selected = false;
		this.edited = false;
		this.checkboxVisible = false;
	}

	_createClass(Item, [{
		key: "select",
		value: function select() {
			this.selected = true;
		}
	}, {
		key: "getSplitProperty",
		value: function getSplitProperty(propname, defaultValue) {
			return this.row.split ? this.row.split[propname] : defaultValue;
		}
	}, {
		key: "splitType",
		get: function get() {
			return this.getSplitProperty('type', 'default');
		}
	}, {
		key: "splitTotalUnits",
		get: function get() {
			return this.getSplitProperty('totalUnits', -1);
		}
	}, {
		key: "splitBookerName",
		get: function get() {
			var bookerId = this.getSplitProperty('bookerId', null);
			return bookerId ? this.row.getBooker(bookerId).name : "";
		}
	}]);

	return Item;
}();

var Pimpl = function () {
	function Pimpl(component) {
		_classCallCheck(this, Pimpl);

		this.component = component;
		this.items = new Map();
		this.onMouseHoverCircle = this._onMouseHoverCircle.bind(this);
		this.onRowClicked = this._onRowClicked.bind(this);
		this.onSelectionInputChanged = this._onSelectionInputChanged.bind(this);
		this.listFeed = new _listfeed2.default(component, this, 'Row');
		this.afterLoadingRows = null;
	}

	_createClass(Pimpl, [{
		key: "init",
		value: function init() {
			var _this = this;

			var component = this.component;
			this.listFeed.init(component.sheet.getLoader('Row', 20), window, component.$refs.rowsList).then(function () {
				_this.component.loading = false;
				if (_this.afterLoadingRows) {
					_this.afterLoadingRows();
					delete _this.afterLoadingRows;
				}
			});

			$(component.$el).on('mouseenter mouseleave touchstart', '.circle', this.onMouseHoverCircle).on('change', '.list-group-item input', this.onSelectionInputChanged).on('click', '.list-group-item', this.onRowClicked);
		}
	}, {
		key: "destroy",
		value: function destroy() {
			$(this.component).off('mouseenter mouseleave touchstart', '.circle', this.onMouseHoverCircle).off('change', '.list-group-item input', this.onSelectionInputChanged).off('click', '.list-group-item', this.onRowClicked);

			this.listFeed.destroy();
		}
	}, {
		key: "_onMouseHoverCircle",
		value: function _onMouseHoverCircle(e) {
			if (this.component.sheet.isOpen) {
				var rowId = Number($(e.target).closest('[data-id]').attr('data-id'));
				this.items.get(rowId).checkboxVisible = e.type !== 'mouseleave';
			}
		}
	}, {
		key: "add",
		value: function add(row, prepend) {
			if (!this.items.has(row.id)) {
				var item = new Item(row);
				this.component.items[prepend ? 'unshift' : 'push'](item);
				this.items.set(row.id, item);
				return true;
			}
		}
	}, {
		key: "remove",
		value: function remove(row) {
			var rowId = row.id;
			if (rowId === this.component.editedRowId) {
				this.component.editedRowId = null;
			}
			var index = this.component.items.findIndex(function (item) {
				return item.row.id === rowId;
			});
			if (index !== -1) {
				this.component.items.splice(index, 1);
				this.items.delete(rowId);
				return true;
			}
		}
	}, {
		key: "createObserver",
		value: function createObserver(observerImpl) {
			return new _store.ChildrenObserver(this.component.sheet.key, observerImpl);
		}
	}, {
		key: "_onRowClicked",
		value: function _onRowClicked(e) {
			var component = this.component;
			if (e.target.nodeName !== 'INPUT') {
				var rowId = Number($(e.target).closest('[data-id]').attr('data-id'));

				if (component.selection.length > 0) {
					this._toggleRowSelection(rowId);
				} else {
					component.showEdit(rowId);
				}
			}
		}
	}, {
		key: "_toggleRowSelection",
		value: function _toggleRowSelection(rowId) {
			var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			var item = this.items.get(Number(rowId));
			if (selected === undefined) {
				selected = !item.selected;
			}
			var selection = this.component.selection;
			if (selected) {
				selected = true;
				if (selection.indexOf(rowId) === -1) {
					selection.push(rowId);
				}
				this.unedit();
			} else {
				selected = false;
				selection.splice(selection.indexOf(rowId), 1);
			}
			item.selected = selected;
		}
	}, {
		key: "_onSelectionInputChanged",
		value: function _onSelectionInputChanged(e) {
			var $input = $(e.target),
			    rowId = Number($input.closest('[data-id]').attr('data-id'));
			this._toggleRowSelection(rowId, $input.is(':checked'));
		}
	}, {
		key: "unedit",
		value: function unedit() {
			if (this.component.editedRowId) {
				this.items.get(this.component.editedRowId).edited = false;
				this.component.editedRowId = null;
			}
		}
	}]);

	return Pimpl;
}();

exports.default = {
	props: {
		sheet: Object,
		anonymousMode: Boolean
	},

	components: {
		Avatar: _avatar2.default,
		IconButton: _iconButton2.default,
		ExpenseEditor: _expenseEditor2.default,
		UserText: _userText2.default,
		SheetBalance: _sheetBalance2.default,
		ExpenseSplitBadge: _expenseSplitBadge2.default,
		LoadingSpacer: _loadingSpacer2.default
	},

	data: function data() {
		return {
			loading: true,
			tabState: this.sheet.closed ? "counters" : "edit",
			subState: '',
			currency: this.sheet.parent.currency,
			items: [],
			deleting: false,
			editedRowId: null,
			selection: [],
			p: new _pimpl2.default(new Pimpl(this)),
			allEntitiesLoaded: false
		};
	},
	created: function created() {
		this.$on('enterState', this.enterState.bind(this));
		this.$on('exitState', this.exitState.bind(this));
	},
	mounted: function mounted() {
		this.p.impl.init();
		$('body').toggleClass('wow-sheet-body', true);
	},
	destroyed: function destroyed() {
		this.p.impl.destroy();
		$('body').toggleClass('wow-sheet-body', false);
	},


	methods: {
		clearSelection: function clearSelection() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					item.selected = false;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.selection.splice(0);
		},
		deleteSelection: function deleteSelection() {
			var _this2 = this;

			this.deleting = true;
			var rows = this.selection.map(function (rowId) {
				return _store2.default.get(_this2.sheet.key, 'Row', rowId);
			});
			this.sheet.removeChildren('Row', this.selection).then(function () {
				_this2.selection.splice(0);
				_toast2.default.cancel(_this2.$formatMessage("expense_deleted", { count: rows.length }), function () {
					return _this2.sheet.addChildren(rows);
				});
			}).always(function () {
				_this2.deleting = false;
			});
		},
		gotoState: function gotoState(stateName) {
			var stateParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var route = { name: stateName, params: stateParams };
			if (this.$route.name === stateName) {
				this.$router.replace(route);
			} else {
				this.$router.push(route);
			}
		},
		enterState: function enterState(stateName, stateParams) {
			var _this3 = this;

			if (this.loading) {
				this.p.impl.afterLoadingRows = function () {
					_this3.enterState(stateName, stateParams);
				};
			} else {
				this.tabState = stateName === 'balance' ? 'counters' : 'edit';
				this.clearSelection();
				if (this.editedRowId) {
					this.p.impl.items.get(this.editedRowId).edited = false;
				}
				if (stateParams.rowId) {
					var rowId = parseInt(stateParams.rowId);
					var rowItem = this.p.impl.items.get(rowId);
					if (rowItem) {
						rowItem.edited = true;
					}
					this.editedRowId = rowId;
				}
				this.subState = "substate substate-" + stateName;
			}
		},
		exitState: function exitState() {
			this.tabState = 'edit';
			this.subState = '';
			this.p.impl.unedit();
		},
		showEdit: function showEdit(rowId) {
			this.$refs.expenseEditor.disableCancelWhenPristine = false;
			if (typeof rowId === 'number') {
				this.gotoState("editRow", { rowId: rowId });
			} else {
				this.gotoState("newRow");
			}
		},
		showBalance: function showBalance() {
			this.gotoState("balance");
		},
		onEditCancelled: function onEditCancelled() {
			var backUrl = this.$route.meta.backUrl;
			if (backUrl) {
				if (typeof backUrl === 'function') backUrl = backUrl(this.$route);
				this.$router.replace(backUrl);
			} else {
				this.p.impl.unedit();
			}
			this.$refs.expenseEditor.disableCancelWhenPristine = true;
		},
		onEditSaved: function onEditSaved() {
			this.$refs.expenseEditor.reset();
			if (this.editedRowId) {
				this.onEditCancelled();
			}
		},
		showTab: function showTab(name) {
			this.gotoState(name === 'edit' ? 'sheet' : 'balance');
		}
	},

	watch: {
		selection: function selection() {
			$(document.body).toggleClass("navbar-mini", this.selection.length > 0);
		}
	}
};

/***/ }),

/***/ "xceO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue__ = __webpack_require__("OsQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589c9497_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_button_vue__ = __webpack_require__("SRvS");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589c9497_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\widgets\\icon-button.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-589c9497", Component.options)
  } else {
    hotAPI.reload("data-v-589c9497", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xq7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue__ = __webpack_require__("tCWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c010e582_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_expenses_state_vue__ = __webpack_require__("hBST");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sheet_expenses_state_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c010e582_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sheet_expenses_state_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\ui\\sheet-expenses-state.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c010e582", Component.options)
  } else {
    hotAPI.reload("data-v-c010e582", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yS/w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _card = __webpack_require__("9KQT");

var _card2 = _interopRequireDefault(_card);

var _iconButton = __webpack_require__("xceO");

var _iconButton2 = _interopRequireDefault(_iconButton);

var _debtsSolver = __webpack_require__("aJcN");

var _debtsSolver2 = _interopRequireDefault(_debtsSolver);

var _payDebt = __webpack_require__("WkD6");

var _payDebt2 = _interopRequireDefault(_payDebt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Card: _card2.default,
		IconButton: _iconButton2.default
	},

	props: {
		book: Object,
		payButton: { type: Boolean, default: false }
	},

	data: function data() {
		return {
			items: (0, _debtsSolver2.default)(this.book.balance, this.book),
			saving: false
		};
	},


	watch: {
		'book.balance': function bookBalance() {
			this.items = (0, _debtsSolver2.default)(this.book.balance, this.book);
		}
	},

	methods: {
		pay: function pay(item) {
			(0, _payDebt2.default)(item, this);
		}
	}
};

/***/ }),

/***/ "yn6c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__("+X65");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var limit = 20;

var ListFeed = function () {
	function ListFeed(component, listModel, kind) {
		_classCallCheck(this, ListFeed);

		this.component = component;
		this.listModel = listModel;
		this.kind = kind;
	}

	_createClass(ListFeed, [{
		key: 'init',
		value: function init(loader, scrollerElement, listElement) {
			var _this = this;

			this.observer = this.listModel.createObserver(this);
			this.loader = loader;
			this.$scroller = $(scrollerElement);
			this.$listElement = $(listElement);

			this.loading = false;
			this.offset = 0;

			this.__onScroll = (0, _throttle2.default)(this._onScroll.bind(this), 20);
			this.$scroller.on('scroll', this.__onScroll);

			this.destroyed = false;

			return this._load().then(function () {
				if (!_this.destroyed) _this.observer.register();
			});
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.observer.unregister();
			if (this.$scroller) {
				this.$scroller.off('scroll', this.__onScroll);
			}
			this.destroyed = true;
		}
	}, {
		key: '_load',
		value: function _load() {
			var _this2 = this;

			this.loading = true;

			return this.loader.load(this.offset).then(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    children = _ref2[0],
				    allLoaded = _ref2[1];

				if (_this2.destroyed) return;

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var child = _step.value;

						_this2.listModel.add(child);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this2.offset += children.length;
				_this2.loading = false;
				_this2.component.allEntitiesLoaded = allLoaded;

				setTimeout(function () {
					_this2.__onScroll();
				}, 10);
			});
		}
	}, {
		key: '_remove',
		value: function _remove(entity) {
			throw 'Not implemented';
		}
	}, {
		key: 'onAdded',
		value: function onAdded(event, eventParams) {
			if (!this.loading && eventParams.kind === this.kind) {
				var added = 0;
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = eventParams.entities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var entity = _step2.value;

						if (this.listModel.add(entity, true)) added += 1;
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				this.offset += added;
			}
		}
	}, {
		key: 'onRemoved',
		value: function onRemoved(event, eventParams) {
			if (eventParams.kind === this.kind) {
				var component = this.component;
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = eventParams.entities[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var entity = _step3.value;

						var removed = 0;
						if (this.listModel.remove(entity)) {
							removed += 1;
						}
						this.offset -= 1;
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
			}
		}
	}, {
		key: '_onScroll',
		value: function _onScroll() {
			if (this.loading || this.component.allEntitiesLoaded) return;

			var $scroller = this.$scroller;
			var scrollerHeight = $scroller.height();
			var scrollerScroll = $scroller.scrollTop();
			var $listElement = this.$listElement;
			var listBottom = $listElement.offset().top + $listElement.height();
			var listItemHeight = $listElement.find('li:first').height();

			if (listBottom < scrollerHeight + scrollerScroll + 2 * listItemHeight) {
				this._load();
			}
		}
	}]);

	return ListFeed;
}();

exports.default = ListFeed;

/***/ }),

/***/ "zvLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("KFRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131cfa4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("D+7J");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("EAHb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131cfa4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\apps\\anonymous\\app.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-131cfa4e", Component.options)
  } else {
    hotAPI.reload("data-v-131cfa4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["gtSB"]);


// WEBPACK FOOTER //
// main.a654b60686728cddaf50.js